import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import useDrivePicker from 'react-google-drive-picker';
import  {PublicClientApplication}  from '@azure/msal-browser'
import { connect, useSelector, useDispatch } from "react-redux";
import {
  Button,
  Input,
  Tooltip,
  Upload,
  Space,
  Table,
  Tag,
  Modal,
  Tabs,
  Select,
  Popover,
  Checkbox,
  TextArea,
  Image,
  Dropdown,
  Radio,
} from "antd";
import { useParams, useHistory, useLocation } from "react-router-dom";

import folderListIcon from "../../../../../images/svg-icons/folder-open-line.svg";
import fileListIcon from "../../../../../images/svg-icons/file-list-3-line.svg";
import fileBackIcon from "../../../../../images/svg-icons/arrow-left-line.svg";
import checkListIcon from "../../../../../images/svg-icons/checkbox-circle-line.svg";


import {
  CheckCircleOutlined,
  DeleteTwoTone,
  DeleteOutlined,
  CloseOutlined,
  UploadOutlined,
  ExclamationCircleFilled,
  EditOutlined,
  CloudUploadOutlined,
  PlusOutlined,
  InfoCircleOutlined,
  EditTwoTone,
  PlayCircleOutlined,
  StopOutlined,
  GlobalOutlined,
  PauseCircleOutlined,
  ThunderboltOutlined,
  ImportOutlined,
} from "@ant-design/icons";

import fileIcon from "../../../../../images/collection-icons/file-text-big.svg";
import urlIcon from "../../../../../images/collection-icons/link.svg";
import textIcon from "../../../../../images/collection-icons/type.svg";

import avatarIcon from "../../../../../images/chat-user.png";
import systemIcon from "../../../../../images/chat-avt.png";
import micIcon from "../../../../../images/mic-icon.png";
import micDefault from "../../../../../images/mic-normal.png";
import micRecording from "../../../../../images/mic-recording.png";
import sumbitIcon from "../../../../../images/submit-white.png";
import analyticsIcon from "../../../../../images/analytics-icon.svg";
import editIcon from "../../../../../images/edit-icon.svg";
import chatHistoryIcon from "../../../../../images/history-icon-2.svg";
import {
  deleteTrainedData,
  getTrainedData,
  uploadDocument,
  uploadUrl,
  queryDocument,
  getChatGPT,
  getDocUploadStatus,
  deleteDocument,
  thumbsAction,
  sendInputAnswer,
} from "../../../../../redux/actions/collections";
import {
  queryDocumentV2,
  uploadDocumentV2,
  uploadDocumentV2AzureService,
  uploadUrlV2,
  getTrainedDataV2,
  deleteTrainedDataV2,
  sendInputAnswerV2,
  getDocUploadStatusV2,
  deleteDocumentV2,
  getWalkthroughs,
  updateWalkthroughs,
  uploadInstructionV2,
  getChatHistoryV2,
  getSqlQueryV2,
  getLiveSearchQuery,
  uploadTextV2,
  updateTextV2,
  getAudio,
  uploadSharepointData,
  uploadGoogleDriveData,
  uploadGoogleDriveDataV2
} from "../../../../../redux/actions/collectionsV2";
import {
  getDraftSkills,
  setDraft,
  executeFlow,
} from "../../../../../redux/actions/skill";
import { notify } from "../../../../../components/Snack";

import Loader from "../../../../../components/loader";

import emptyIcon from "../../../../../images/empty.png";
import arrowBack from "../../../../../images/pagination/chevron-left.svg";

import $ from "jquery";
import marked from "marked";

import Chart from "chart.js/auto";
import { Line, Bar, Pie, Doughnut, PolarArea, Radar } from "react-chartjs-2";
// const SpeechSDK = require("microsoft-cognitiveservices-speech-sdk");
// const { SpeechConfig, SpeechSynthesizer, AudioConfig, ResultReason } =
//   SpeechSDK;
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

  const msalConfig = {
    auth: {
      clientId: process.env?.REACT_APP_SHAREPOINT_CLIENT_ID,
      authority: process.env?.REACT_APP_SHAREPOINT_AUTHORITY,
      redirectUri: process.env.REACT_APP_WEB_APP_URL
    },
  };
  const msalInstance = new PublicClientApplication(msalConfig);

  const init1 = async () => {
    try {
      await msalInstance.initialize();
    } catch (error) {
      console.error('Initialization failed:', error);
    }
  }

const Collection = () => {
  
  useEffect(() => {
    init1();
  }, []);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/api.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);
  const [openPicker] = useDrivePicker();
  const speechRef = useRef(null);
  const isSpeakingRef = useRef(false);
  const voicesRef = useRef([]);
  const selectedVoiceRef = useRef(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/api.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);
  const handleUpdateVoice = (value) => {
    console.log(value, "ppppppppppppppppp");
    selectedVoiceRef.current = value;
    setSelectedVoice(value);
  };
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleChange = ({ file, fileList: newFileList }) => {
    const docFileTypeArray = file?.name?.split(".");

    const docFileType = docFileTypeArray[docFileTypeArray?.length - 1];
    const validFileTypes = [
      "png",
      "jpg",
      "mp3",
      "mp4",
      "wav",
      "m4a",
      "mpeg",
      "flac",
    ];
    if (validFileTypes.includes(docFileType?.toLowerCase())) {
      setFileList(newFileList);
      if (newFileList[0]?.type?.includes("audio")) {
        setQueryText("Audio file uploaded");
      }
    } else {
      dispatch(notify("error", "Please select an allowed file format"));
    }
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );
  const { Option } = Select;
  const history = useHistory();
  const dispatch = useDispatch();
  const queryParams = useLocation().search;

  const [_trainedDataList, _setTrainedDataList] = useState([]);
  const [_chatHistoryList, _setChatHistoryList] = useState([]);

  const [_walkthroughsList, _setWalkthroughsList] = useState([]);
  const [walkthroughsListTemp, setWalkthroughsListTemp] = useState([]);
  const [inAppWalkthroughData, setInAppWalkthroughData] = useState([]);
  const [walkthroughFlag, setWalkthroughFlag] = useState(false);
  const [walkthroughsSelected, setWalkthroughsSelected] = useState([]);
  const [walkthroughToDelete, setWalkthroughToDelete] = useState("");

  const [uploadFileData, setUploadFileData] = useState([]);
  const [collectionName, setCollectionName] = useState("");
  const [docCount, setDocCount] = useState(0);

  const [loading, setLoading] = useState(false);
  const [fileUploading, setFileUploading] = useState(false);
  const [urlInput, setUrlInput] = useState(false);

  const [uploadURLText, setUploadURLText] = useState("");
  const [resourceName, setResourceName] = useState("");

  const [queryData, setQueryData] = useState([]);
  const [walkthroughResponse, setWalkthroughResponse] = useState([]);

  const [queryText, setQueryText] = useState("");
  const [chatGptQueryText, setChatGptQueryText] = useState("");
  const [queryResponse, setQueryResponse] = useState("");
  const [queryResponseId, setQueryResponseId] = useState("");

  const [disliked, setDisliked] = useState(false);
  const [liked, setLiked] = useState(false);

  const [docSelected, setDocSelected] = useState("");

  const [docList, setDocList] = useState([]);
  const [docListTemp, setDocListTemp] = useState([]);

  const [askSuper, setAskSuper] = useState(false);
  const [chatHistoryFlag, setChatHistoryFlag] = useState(false);
  const [viewTrainedData, setViewTrainedData] = useState(false);
  const [sendAnswer, setSendAnswer] = useState(false);
  const [answerText, setAnswerText] = useState("");
  const [questionText, setQuestionText] = useState("");
  const [filePath, setFilePath] = useState("");
  const [oldAnswerText, setOldAnswerText] = useState("");
  const [newAnswerText, setNewAnswerText] = useState("");
  const [micStatus, setMicStatus] = useState(false);
  const [micInputText, setMicInputText] = useState("");
  const [chatContext, setChatContext] = useState(" ");
  const [docURL, setDocURL] = useState("");
  const [ocrFlag, setOcrFlag] = useState("false");
  const [instruction, setInstruction] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [addText, setAddText] = useState(false);
  const [textValue, setTextValue] = useState("");
  const [uploadInput, setUploadInput] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [updatedTextValue, setUpdatedTextValue] = useState("");
  const [existingResourceName, setExistingResourceName] = useState("");

  const [uploadType, setUploadType] = useState("local_upload");

  const [clientID, setClientID] = useState("");
  const [clientSecretID, setClientSecretID] = useState("");
  const [tenantID, setTenantID] = useState("");
  const [uploadSiteName, setUploadSiteName] = useState("");
  const [sharePointSiteID, setSharePointSiteID] = useState("");
  const [folderPath, setFolderPath] = useState("");
  const [fileTypes, setFileTypes] = useState("");

  // const [imageUploadFlag, setImageUploadFlag] = useState(true);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [textQueue, setTextQueue] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [voices, setVoices] = useState([]);
  const [selectedVoice, setSelectedVoice] = useState(null);

  const [driveFolderSelected, setDriveFolderSelected] = useState(true);

  const userDetails = useSelector(
    (state) => state.organizationReducer.currentOrganization
  );
  const trainedDataList = useSelector(
    (state) => state.collectionReducer.trainedData
  );
  const collectionSource = useSelector(
    (state) => state.collectionReducer.collectionSource
  );

  const collectionDocs = useSelector(
    (state) => state.collectionReducer?.collectionDocs
  );

  const chatHistoryDataList = useSelector(
    (state) => state.collectionReducer.chatHistoryData
  );
  const walkthroughsList = useSelector(
    (state) => state.collectionReducer.walkthroughsData
  );
  const groupPlan = useSelector((state) => state.userReducer.groupPlan);
  const userEmail = useSelector((state) => state.userReducer.user?.email);
  let instructionList = useSelector(
    (state) => state.collectionReducer.instructionData
  );
  const minMode = useSelector((state) => state.appReducer.minMode);

  let orgFilterFlag = false;
  try {
    const orgIdToFilterList = process.env?.REACT_APP_FILTERED_ORG_IDS_COLLECTION
      ? JSON.parse(process.env.REACT_APP_FILTERED_ORG_IDS_COLLECTION)
      : [];
    orgFilterFlag = orgIdToFilterList?.includes(JSON.parse(userDetails?.id));
  } catch {
    orgFilterFlag = false;
  }

  let planType;
  if (groupPlan?.planId == 4) {
    planType = "team";
  } else if (groupPlan?.planId == 5) {
    planType = "business";
  } else {
    planType = "pro";
  }

  const onWalkThroughSelectionChange = (key, item) => {
    setWalkthroughsSelected(item);
  };

  const saveWalkthrough = async () => {
    try {
      if (walkthroughsSelected?.length > 0) {
        setWalkthroughFlag(false);
        const walkthroughsPayload =
          walkthroughsList?.concat(walkthroughsSelected);
        let walkthroughResponse = await dispatch(
          updateWalkthroughs(
            new URLSearchParams(queryParams).get("name"),
            walkthroughsPayload
          )
        );

        if (walkthroughResponse?.status == 200) {
          dispatch(
            notify("success", "Walkthrough successfully added to collection")
          );
          _setWalkthroughsList(walkthroughsPayload);
          onSearchWalkthroughs("");
          dispatch(
            getWalkthroughs(new URLSearchParams(queryParams).get("name"))
          );
          setWalkthroughsSelected([]);
        } else {
          dispatch(
            notify("error", "Walkthrough updation failed. Please try again.")
          );
        }
      } else {
        dispatch(notify("error", "Please select atleast one option"));
      }
    } catch {
      dispatch(notify("error", "Something went wrong. Please try again."));
    }
  };

  const speechToText = () => {
    setMicStatus(true);

    var SpeechRecognition = SpeechRecognition || window.webkitSpeechRecognition;
    var recognition = new SpeechRecognition();

    recognition.onstart = () => {
      sendAnswer ? setAnswerText("Listening...") : setQueryText("Listening...");
    };

    recognition.onspeechend = () => {
      setMicStatus(false);
      recognition.stop();
      //sendAnswer ? setAnswerText('') : setQueryText('');
    };

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      sendAnswer ? setAnswerText(transcript) : setQueryText(transcript);
      setMicInputText(transcript);
    };

    recognition.start();
  };

  const props = {
    onChange(info) {
      setUploadFileData(info.file.originFileObj);
      setFilePath(info.file.name);
    },
  };
  const propsUploadTokenFile = {
    onChange(info) {
      setUploadFileData(info.file);
      setFilePath(info.file.name);
    },
  };

  useEffect(() => {
    _setTrainedDataList(trainedDataList);
  }, [trainedDataList]);

  useEffect(() => {
    _setTrainedDataList(trainedDataList);
  }, [trainedDataList]);

  useEffect(() => {
    _setChatHistoryList(chatHistoryDataList);
  }, [chatHistoryDataList]);

  const chatHistoryData = async (collectionName) => {
    setChatHistoryFlag(true);
    // dispatch(getChatHistoryV2(collectionName, userEmail)).then(() => {
    //   setChatHistoryFlag(true);
    // });
  };

  useEffect(() => {
    _setWalkthroughsList(walkthroughsList);
    setInstruction(instructionList);
    setWalkthroughsListTemp(walkthroughsList);
  }, [walkthroughsList, instructionList]);

  useEffect(() => {
    if (micInputText?.length > 0) {
      setMicInputText("");
    }
  }, [micInputText]);

  useEffect(() => {
    let colors = [
      "#f54747",
      "#8a5fff",
      "#ffa933",
      "#ff6233",
      "#1d262e",
      "#297bff",
      "#ff2963",
      "#21b8dd",
    ];
    let count = 0;
    $(".cts-avatar").each(function () {
      $(this).css("background-color", colors[count]);
      count++;
      if (count === colors.length) {
        count = 0;
      }
    });
    $(".tl-block").removeClass("active");
  }, [docList]);

  useEffect(() => {
    let colors = [
      "#f54747",
      "#8a5fff",
      "#ffa933",
      "#ff6233",
      "#1d262e",
      "#297bff",
      "#ff2963",
      "#21b8dd",
    ];
    let count = 0;
    $(".cts-avatar-wlk").each(function () {
      $(this).css("background-color", colors[count]);
      count++;
      if (count === colors.length) {
        count = 0;
      }
    });
    $(".tl-block").removeClass("active");
  }, [_walkthroughsList]);

  const queryCollection = async () => {
    setAskSuper(true);
    setViewTrainedData(false);
  };

  const trainedData = async () => {
    orgFilterFlag
      ? dispatch(getTrainedData(new URLSearchParams(queryParams).get("name")))
      : dispatch(
          getTrainedDataV2(new URLSearchParams(queryParams).get("name"))
        );
    setAskSuper(false);
    setViewTrainedData(true);
  };

  const uploadView = async () => {
    setAskSuper(false);
    setViewTrainedData(false);
  };

  const clearFilePath = async () => {
    setFilePath("");
    setUploadFileData([]);
  };

  const deleteUploadedAnswer = async (record) => {
    setLoading(true);
    if (orgFilterFlag) {
      dispatch(
        deleteTrainedData(collectionName, record.id, record.question)
      ).then(() => {
        dispatch(getTrainedData(collectionName)).then(() => {
          dispatch(notify("success", "Deleted answer successfully"));
          setLoading(false);
        });
      });
    } else {
      dispatch(
        deleteTrainedDataV2(
          collectionName,
          record.id,
          record.question,
          planType
        )
      ).then(() => {
        dispatch(getTrainedDataV2(collectionName)).then(() => {
          dispatch(notify("success", "Deleted answer successfully"));
          setLoading(false);
        });
      });
    }
  };

  const deleteDoc = async (obj) => {
    setLoading(true);
    const index = orgFilterFlag
      ? docList.indexOf(obj)
      : docList.map((temp) => temp["document_name"]).indexOf(obj);
    if (index > -1) {
      docList.splice(index, 1);
    }

    const uploadDocumentResponse = orgFilterFlag
      ? await deleteDocument(collectionName, obj)
      : await deleteDocumentV2(collectionName, obj, planType);

    if (uploadDocumentResponse?.status == "OK") {
      setDocList(docList);
      setDocListTemp(docList);
      dispatch(notify("success", "The document has been successfully removed."));
    } else {
      dispatch(notify("error", "Document removal failed."));
    }
    setDocSelected("");
    setLoading(false);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      newCollectionQuery();
    }
  };

  const handleKeyPressOnSendAnswer = (event) => {
    if (event.key === "Enter") {
      sendUserAnswer();
    }
  };
  useEffect(() => {
    if (disliked) {
      if (queryResponse?.chartType) {
        setQueryText("");
        let chartData = queryResponse?.data;

        setQueryData((previousArr) =>
          previousArr.slice(-(previousArr?.length - 1))
        );

        const query = (
          <div className="mac-chat mac-left">
            <div className="mac-avt">
              <img src={systemIcon} alt="" />
            </div>
            <div className="mac-text">
              {getChart(chartData)}

             <div className="thumbs-action">
                <i className="fa fa-thumbs-up"></i>
                <i className="fa fa-thumbs-down dislike"></i>
              </div>
            </div>
          </div>
        );

        setQueryData((current) => [query, ...current]);
        thumbsAction(queryResponseId, true);
      } else if (queryResponse?.length > 0) {
        // Check if queryResponse is an array
        let markdownContent;
        if (Array.isArray(queryResponse)) {
          markdownContent = convertArrayToMarkdownTable(queryResponse);
        } else {
          markdownContent = queryResponse; // Assuming it's already a string
        }
        let htmlResponseParsed = marked(markdownContent);
        htmlResponseParsed = htmlResponseParsed.replaceAll(
          "href=",
          'target="_blank" href='
        );

        setQueryData((previousArr) =>
          previousArr.slice(-(previousArr?.length - 1))
        );
       const query = (
          <div className="mac-chat mac-left">
            <div className="mac-avt">
              <img src={systemIcon} alt="" />
            </div>
            <div className="mac-text">
              <p
                //className="mac-white"
                className={
                  Array.isArray(queryResponse) ? "data-chat-table" : "mac-white"
                }
                dangerouslySetInnerHTML={{ __html: htmlResponseParsed }}
              ></p>
              <div className="thumbs-action">
                <i className="fa fa-thumbs-up"></i>
                <i className="fa fa-thumbs-down dislike"></i>
              </div>
            </div>
          </div>
        );

        setQueryData((current) => [query, ...current]);
        thumbsAction(queryResponseId, false);

        if (userDetails?.role_id != "1") {
          getUserAnswer();
        }
      }
      setDisliked(false);
    }
  }, [disliked]);
  
  useEffect(() => {
    if (liked) {
      if (queryResponse?.chartType) {
        setQueryText("");
        let chartData = queryResponse?.data;

        setQueryData((previousArr) =>
          previousArr.slice(-(previousArr?.length - 1))
        );

        const query = (
          <div className="mac-chat mac-left">
            <div className="mac-avt">
              <img src={systemIcon} alt="" />
            </div>
            <div className="mac-text">
              {getChart(chartData)}

             <div className="thumbs-action">
                <i className="fa fa-thumbs-up liked"></i>
                <i className="fa fa-thumbs-down"></i>
              </div>
            </div>
          </div>
        );

        setQueryData((current) => [query, ...current]);
        thumbsAction(queryResponseId, true);
      } else if (queryResponse?.length > 0) {
        // Check if queryResponse is an array
        let markdownContent;
        if (Array.isArray(queryResponse)) {
          markdownContent = convertArrayToMarkdownTable(queryResponse);
        } else {
          markdownContent = queryResponse; // Assuming it's already a string
        }
        let htmlResponseParsed = marked(markdownContent);
        htmlResponseParsed = htmlResponseParsed.replaceAll(
          "href=",
          'target="_blank" href='
        );

        setQueryData((previousArr) =>
          previousArr.slice(-(previousArr?.length - 1))
        );
        const query = (
          <div className="mac-chat mac-left">
            <div className="mac-avt">
              <img src={systemIcon} alt="" />
            </div>
            <div className="mac-text">
              <p
                className="mac-white"
                dangerouslySetInnerHTML={{ __html: htmlResponseParsed }}
              ></p>
              <div className="thumbs-action">
                <i className="fa fa-thumbs-up liked"></i>
                <i className="fa fa-thumbs-down"></i>
              </div>
            </div>
          </div>
        );
        setQueryData((current) => [query, ...current]);
        thumbsAction(queryResponseId, true);
      }
      setLiked(false);
    }
  }, [liked]);

  const queryChatGPT = async () => {
    setQueryResponse("");
    const query = (
      <div className="mac-chat mac-left">
        <div className="mac-avt">
          <img src={systemIcon} alt="" />
        </div>
        <div className="mac-text">
          <p className="mac-white">
            Please wait while we fetch the answer from web...
          </p>
        </div>
      </div>
    );

    setQueryData((current) => [query, ...current]);
    const queryResult = await getChatGPT(chatGptQueryText);
    setQueryResponse(queryResult);
  };

  const readInputAnswer = async () => {
    setQueryResponse("");
    setQueryData((previousArr) =>
      previousArr.slice(-(previousArr?.length - 1))
    );

    const staticQuery = (
      <div className="mac-chat mac-left">
        <div className="mac-avt">
          <img src={systemIcon} alt="" />
        </div>
        <div className="mac-text">
          <p className="mac-white">
            I'm sorry if my response didn't meet your expectations. Would you
            like to provide me the right answer so I can do better next time?
          </p>
          <div className="mac-flex-btn">
            <button className="btn btn-primary btn-rounded btn-small">
              Yes
            </button>
            <button className="btn btn-danger btn-rounded btn-small">No</button>
          </div>
        </div>
      </div>
    );

    setQueryData((current) => [staticQuery, ...current]);

    const query = (
      <div className="mac-chat mac-left">
        <div className="mac-avt">
          <img src={systemIcon} alt="" />
        </div>
        <div className="mac-text">
          <p className="mac-white">Enter your answer</p>
        </div>
      </div>
    );

    setQueryData((current) => [query, ...current]);
  };

  const noAnswerSelected = async () => {
    const query = (
      <div className="mac-chat mac-left">
        <div className="mac-avt">
          <img src={systemIcon} alt="" />
        </div>
        <div className="mac-text">
          <p className="mac-white">Thank you!</p>
        </div>
      </div>
    );

    setQueryData((current) => [query, ...current]);
  };

  const newCollectionQuery = async () => {
    setChatHistoryFlag(false);

    if (queryText?.length > 0) {
      // setImageUploadFlag(false);
      setFileList([]);

      if (queryResponse?.length > 0) {
        let markdownContent;
        if (Array.isArray(queryResponse)) {
          markdownContent = convertArrayToMarkdownTable(queryResponse);
        } else {
          markdownContent = queryResponse;
        }

        let htmlResponseParsed = marked(markdownContent);
        htmlResponseParsed = htmlResponseParsed.replaceAll(
          "href=",
          'target="_blank" href='
        );

        setQueryData((previousArr) =>
          previousArr.slice(-(previousArr?.length - 1))
        );
        const queryTemp = (
          <div className="mac-chat mac-left">
            <div className="mac-avt">
              <img src={systemIcon} alt="" />
            </div>
            <div className="mac-text">
              <p
                //className="mac-white"
                className={
                  Array.isArray(queryResponse) ? "data-chat-table" : "mac-white"
                }
                dangerouslySetInnerHTML={{ __html: htmlResponseParsed }}
              ></p>
              <div className="thumbs-action">
                <i className="fa fa-thumbs-up"></i>
                <i className="fa fa-thumbs-down"></i>
              </div>
            </div>
          </div>
        );
        setQueryData((current) => [queryTemp, ...current]);
      }

      setQueryResponse("");
      const query = (
        <div className="mac-chat mac-right">
          <div className="mac-text">
            <p className="mac-black">{queryText}</p>
            <p>
              <Space>
                {fileList?.map((obj, ind) => {
                  return <Image width={150} src={obj?.thumbUrl} />;
                })}
              </Space>
            </p>
          </div>
          <div className="mac-avt">
            <img src={avatarIcon} alt="" />
          </div>
        </div>
      );

      setChatGptQueryText(queryText);
      setQueryText("");
      setQueryData((current) => [query, ...current]);

      const message = (
        <div className="mac-chat mac-left">
          <div className="mac-avt">
            <img src={systemIcon} alt="" />
          </div>
          <div className="mac-text">
            <p className="typing">
              <span></span>
              <span></span>
              <span></span>
            </p>
          </div>
        </div>
      );
      setQueryData((current) => [message, ...current]);

      let docName = "";
      if ($(".tl-block").hasClass("active")) {
        docName = docSelected?.split(".")[0];
      }

      let imageFileData = [];
      fileList?.map((obj, ind) => {
        imageFileData.push(obj?.originFileObj);
      });

      let queryResult;
      if (orgFilterFlag) {
        queryResult = await queryDocument(
          queryText,
          collectionName,
          docName,
          chatContext
        );
      } else {
        const queryQuestion = queryText;
        console.log("collection source 882:",collectionSource)
        if (collectionSource === "database") {
          queryResult = await getSqlQueryV2(queryQuestion, collectionName);
          setQueryResponse(queryResult.response)
        } 
        else if (collectionSource === "live_search") {
          console.log("in livesearch");
          queryResult = await getLiveSearchQuery(queryQuestion, collectionName,planType);
        } else {
          queryResult = await queryDocumentV2(
            queryQuestion,
            collectionName,
            docName,
            chatContext,
            planType,
            imageFileData
          );
        }
      }

      if (queryResult?.is_table === true) {
        const tableData = queryResult.response;
        const table = (
          <Table className="data-chat-table">
            <thead>
              <tr>
                {Object.keys(tableData[0]).map((key) => (
                  <th key={key}>{key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index}>
                  {Object.values(row).map((value, idx) => (
                    <td key={idx}>{value}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        );
        setQueryData((previousArr) =>
          previousArr.slice(-(previousArr?.length - 1))
        );
        setQueryData((current) => [table, ...current]);

        setAnswerText("");
        setQuestionText("");
        setSendAnswer(false);
      }

      if (queryResult?.is_table === false) {
        const textData = queryResult.response;
        const query = (
          <div className="mac-chat mac-right">
            <div className="mac-text">
              <p className="mac-black">{answerText}</p>
            </div>
            <div className="mac-avt">
              <img src={avatarIcon} alt="" />
            </div>
          </div>
        );

        setQueryData((previousArr) =>
          previousArr.slice(-(previousArr?.length - 1))
        );
        setQueryData((current) => [query, ...current]);

        setAnswerText("");
        setQuestionText("");
        setSendAnswer(false);
      }

      if (queryResult?.is_visualization) {
        if (queryResult?.response[0]?.error) {
          setQueryData((previousArr) =>
            previousArr.slice(-(previousArr?.length - 1))
          );

          const query = (
            <div className="mac-chat mac-left">
              <div className="mac-avt">
                <img src={systemIcon} alt="" />
              </div>
              <div className="mac-text">
                <p className="mac-white">
                  Chart generation failed. Please rephrase the question and try
                  again.
                </p>
              </div>
            </div>
          );
          setQueryData((current) => [query, ...current]);
        } else {
          setQueryData((previousArr) =>
            previousArr.slice(-(previousArr?.length - 1))
          );

          queryResult?.response[0]?.response
            ? setQueryResponse(queryResult?.response[0]?.response)
            : setQueryResponse(queryResult?.response[0]);
          setQueryResponseId(queryResult?.query_id);
        }
      } else {
        setWalkthroughResponse(queryResult?.skill_recommended);

        setQueryData((previousArr) =>
          previousArr.slice(-(previousArr?.length - 1))
        );

        setQueryResponse(queryResult?.response);
        setQueryResponseId(queryResult?.query_id);
        setQuestionText(queryText);

        setEditQuestionText(queryText);
        setEditAnswerOldText(queryResult?.response);
        setChatContext(queryResult?.chat_context);
      }
      dispatch(getChatHistoryV2(collectionName, userEmail));
      const textareaInput = document.getElementById("text-area-input");
      textareaInput.value = "";
    } else {
      dispatch(
        notify(
          "error",
          "Query field cannot be empty. Please enter a valid query"
        )
      );
    }
  };

  const handleEditClick = async (doc) => {
    const result = await dispatch(
      getWalkthroughs(new URLSearchParams(queryParams).get("name"))
    );
    const DocsList = result.message?.document_names;
    const document = DocsList.find(
      (item) => item.document_name === doc?.document_name
    );

    setIsEditing(true);
    setExistingResourceName(doc?.document_name);
    setUploadInput(false);
    setUrlInput(false);
    setAddText(false);
    if (document) {
      setUpdatedTextValue(document.text_data || "");
    } else {
      setUpdatedTextValue("");
    }
  };

  const sendUserAnswer = async () => {
    let docName = "";
    if ($(".tl-block").hasClass("active")) {
      docName = docSelected?.split(".")[0];
    }

    const query = (
      <div className="mac-chat mac-right">
        <div className="mac-text">
          <p className="mac-black">{answerText}</p>
        </div>
        <div className="mac-avt">
          <img src={avatarIcon} alt="" />
        </div>
      </div>
    );

    setQueryData((current) => [query, ...current]);

    setAnswerText("");
    setQuestionText("");
    setSendAnswer(false);

    const message = (
      <div className="mac-chat mac-left">
        <div className="mac-avt">
          <img src={systemIcon} alt="" />
        </div>
        <div className="mac-text">
          <p className="typing">
            <span></span>
            <span></span>
            <span></span>
          </p>
        </div>
      </div>
    );

    setQueryData((current) => [message, ...current]);

    const sendAnswerResponse = orgFilterFlag
      ? await sendInputAnswer(
          collectionName,
          queryResponseId,
          editQuestionText,
          editAnswerOldText,
          answerText
        )
      : await sendInputAnswerV2(
          collectionName,
          queryResponseId,
          editQuestionText,
          editAnswerOldText,
          answerText,
          planType
        );

    setChatContext(" ");
    setQueryData((previousArr) =>
      previousArr.slice(-(previousArr?.length - 1))
    );

    if (sendAnswerResponse?.status == "OK") {
      const message = (
        <div className="mac-chat mac-left">
          <div className="mac-avt">
            <img src={systemIcon} alt="" />
          </div>
          <div className="mac-text">
            <p className="mac-white">
              Thank you for the details. I will update my knowledge and strive
              to provide more relevant answers next time.
            </p>
          </div>
        </div>
      );

      setQueryData((current) => [message, ...current]);
    } else {
      const message = (
        <div className="mac-chat mac-left">
          <div className="mac-avt">
            <img src={systemIcon} alt="" />
          </div>
          <div className="mac-text">
            <p className="mac-white">
              Something went wrong. Please try again later.
            </p>
          </div>
        </div>
      );

      setQueryData((current) => [message, ...current]);
    }
    const textareaInput = document.getElementById("text-area-input");
    textareaInput.value = "";
  };

  const getUserAnswer = async () => {
    setQueryResponse("");
    const query = (
      <div className="mac-chat mac-left">
        <div className="mac-avt">
          <img src={systemIcon} alt="" />
        </div>
        <div className="mac-text">
          <p className="mac-white">
            I'm sorry if my response didn't meet your expectations. Would you
            like to provide me the right answer so I can do better next time?
          </p>
          <div className="mac-flex-btn">
            <button
              className="btn btn-primary btn-rounded btn-small"
              onClick={(e) => {
                setSendAnswer(true);
                readInputAnswer();
              }}
            >
              Yes
            </button>
            <button
              className="btn btn-danger btn-rounded btn-small"
              onClick={() => {
                setSendAnswer(false);
                noAnswerSelected();
              }}
            >
              No
            </button>
          </div>
        </div>
      </div>
    );

    setQueryData((current) => [query, ...current]);
    //const queryResult = await getChatGPT(chatGptQueryText);
    //setQueryResponse(query)
  };

  let queryBody = [];
  queryBody.push(
    <div className="mac-chat mac-left">
      <div className="mac-avt">
        <img src={systemIcon} alt="" />
      </div>
      <div className="mac-text">
        <p className="mac-white">Hi, I'm Super</p>
        <p className="mac-white">How may I assist you today?</p>
      </div>
    </div>
  );

  const getChart = (chartData) => {
    switch (queryResponse?.chartType) {
      case "line":
        return (
          <p class="mac-white">
            <Line data={chartData} />
          </p>
        );
      case "bar":
        return (
          <p class="mac-white">
            <Bar data={chartData} />
          </p>
        );
      case "pie":
        return (
          <p class="mac-white">
            <Pie data={chartData} />
          </p>
        );
      case "doughnut":
        return (
          <p class="mac-white">
            <Doughnut data={chartData} />
          </p>
        );
      case "polarArea":
        return (
          <p class="mac-white">
            <PolarArea data={chartData} />
          </p>
        );
      case "radar":
        return (
          <p class="mac-white">
            <Radar data={chartData} />
          </p>
        );
      default:
        return null;
    }
  };

  const getDatabaseCollectionChart = (chartData) => {
    switch (collectionSource === "database" && queryResponse?.chartType) {
      case "line":
        return (
          <p class="mac-white">
            <Line data={chartData} />
          </p>
        );
      case "bar":
        return (
          <p class="mac-white">
            <Bar data={chartData} />
          </p>
        );
      case "pie":
        return (
          <p class="mac-white">
            <Pie data={chartData} />
          </p>
        );
      case "doughnut":
        return (
          <p class="mac-white">
            <Doughnut data={chartData} />
          </p>
        );
      case "polarArea":
        return (
          <p class="mac-white">
            <PolarArea data={chartData} />
          </p>
        );
      case "radar":
        return (
          <p class="mac-white">
            <Radar data={chartData} />
          </p>
        );
      default:
        return null;
    }
  };

  const speakText = (response) => {
    let lang = selectedVoiceRef.current ? selectedVoiceRef.current : "en-US	";
    let audio = dispatch(getAudio(lang, response));
  };

  const handlePlay = () => {
    const textToSpeak = speechRef?.current;
    speakText(textToSpeak);
  };
  const handlePause = () => {
    let audioElement = document.getElementById("audioPlayer");
    audioElement.pause();
    audioElement.currentTime = 0;
  };

  useEffect(() => {
  
    if (queryResponse?.chartType) {
      setQueryText("");
      let chartData = queryResponse?.data;

      if (collectionSource === 'database') {  const query = (
        <div className="mac-chat mac-left">
          <div className="mac-avt">
            <img src={systemIcon} alt="" />
          </div>
          <div className="mac-text">
            {getDatabaseCollectionChart(chartData)}

           <div className="thumbs-action mac-text-thumbs">
              <i
                className="fa fa-thumbs-up"
                onClick={() => {
                  setLiked(true);
                }}
              ></i>
              <i
                className="fa fa-thumbs-down"
                onClick={() => {
                  setDisliked(true);
                }}
              ></i>
            </div>
          </div>
        </div>
      );

      setQueryData((current) => [query, ...current]);
    } else {
      const query = (
      <div className="mac-chat mac-left">
        <div className="mac-avt">
          <img src={systemIcon} alt="" />
        </div>
        <div className="mac-text">
          {getChart(chartData)}

         <div className="thumbs-action mac-text-thumbs">
            <i
              className="fa fa-thumbs-up"
              onClick={() => {
                setLiked(true);
              }}
            ></i>
            <i
              className="fa fa-thumbs-down"
              onClick={() => {
                setDisliked(true);
              }}
            ></i>
          </div>
        </div>
      </div>
    );

    setQueryData((current) => [query, ...current]);
  } } 
    else if (queryResponse?.length > 0) {
      // Check if queryResponse is an array
      let markdownContent;
      if (Array.isArray(queryResponse)) {
        markdownContent = convertArrayToMarkdownTable(queryResponse);
      } else {
        markdownContent = queryResponse; // Assuming it's already a string
      }
      // Convert the markdown content to HTML
      let htmlResponseParsed = marked(markdownContent);
      htmlResponseParsed = htmlResponseParsed.replaceAll(
        "href=",
        'target="_blank" href='
      );

      const query = (
        <div className="mac-chat mac-left">
          <div className="mac-avt">
            <img src={systemIcon} alt="" />
          </div>
          <div className="mac-text">
            {/* Play Text  */}
            <div className="mac-icon-select">
              {/* Select Language */}
              {/* <Tooltip title="Select Voice Language">
                <Select
                  defaultValue={
                    selectedVoiceRef?.current == "hi-IN-AditiNeural"
                      ? "हिन्दी"
                      : "English"
                  }
                  style={{
                    width: 150,
                  }}
                  onChange={handleUpdateVoice}
                  placeholder="Select Language"
                >
                  <Option>
                    <Option value="en-US-David">English"</Option>

                    <Option value="hi-IN-AditiNeural">"हिन्दी"</Option>
                  </Option>
                </Select>
              </Tooltip> */}
              
              {/* 
              <div className="mac-icon-click">
                <Tooltip title="Read aloud">
                  <button
                    onClick={() => {
                      speechRef.current = queryResponse;
                      handlePlay();
                    }}
                    className={"m-chat-play"}
                  >
                    <PlayCircleOutlined className="play-icon" />
                    <PauseCircleOutlined className="pause-icon" />
                  </button>
                </Tooltip>
                <Tooltip title="Stop audio">
                  <button
                    onClick={() => {
                      speechRef.current = queryResponse;
                      handlePause();
                    }}
                    className={"m-chat-play active"}
                  >
                    <PlayCircleOutlined className="play-icon" />
                    <PauseCircleOutlined className="pause-icon" />
                  </button>
                </Tooltip>
              </div> */}
            </div>
            <p
              className={
                Array.isArray(queryResponse) ? "data-chat-table" : "mac-white"
              }
              dangerouslySetInnerHTML={{ __html: htmlResponseParsed }}
            ></p>

            {/* <span className="suggestion">If the given answer doesn't help, press <i className="fa fa-thumbs-down inline-thumb" /> to search from public knowledge (may not be accurate).</span> */}
            <div className="thumbs-action mac-text-thumbs">
              <i
                className="fa fa-thumbs-up"
                onClick={() => {
                  setLiked(true);
                }}
              ></i>
              <i
                className="fa fa-thumbs-down"
                onClick={() => {
                  setDisliked(true);
                }}
              ></i>
            </div>
            {walkthroughResponse?.length > 0 ? (
              <h5>
                Need further guidance? Trigger any of the below related
                walkthroughs to get live assistance.
              </h5>
            ) : null}
            <div className="chat-btns">
              {walkthroughResponse?.map((obj, ind) => {
                return obj?.SKILL_NAME?.length < 25 ? (
                  <Button onClick={(e) => executeSkill(obj)} type="primary">
                    {obj?.SKILL_NAME}
                  </Button>
                ) : (
                  <Popover content={obj?.SKILL_NAME}>
                    <Button onClick={(e) => executeSkill(obj)} type="dashed">
                      {obj?.SKILL_NAME.slice(0, 25) + "..."}
                    </Button>
                  </Popover>
                );
              })}
            </div>
          </div>
        </div>
      );
      setQueryData((current) => [query, ...current]);
      setWalkthroughResponse([]);
    }
  }, [queryResponse]);

  const convertArrayToMarkdownTable = (dataArray) => {
    if (!dataArray.length) return "";

    // Extract the keys for the header row from the first object
    const headers = Object.keys(dataArray[0]);
    const headerRow = `| ${headers.join(" | ")} |`;
    const separatorRow = `| ${headers.map(() => "---").join(" | ")} |`;
    // Create the rows for each object in the array
    const dataRows = dataArray.map((row) => {
      return `| ${Object.values(row).join(" | ")} |`;
    });
    // Combine header, separator, and data rows into a single markdown string
    return [headerRow, separatorRow, ...dataRows].join("\n");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await dispatch(
          getWalkthroughs(new URLSearchParams(queryParams).get("name"))
        );
        const documentsList = result?.message?.document_names;
        setCollectionName(new URLSearchParams(queryParams).get("name"));
        new URLSearchParams(queryParams).get("c")
          ? setDocCount(parseInt(new URLSearchParams(queryParams).get("c")))
          : setDocCount(0);
        setQueryData(queryBody);
        setCollectionName(new URLSearchParams(queryParams).get("name"));
        if (orgFilterFlag) {
          let docArray = [];
          const tempDocList = history.location.state?.documents;
          docArray = tempDocList ? tempDocList : [];
          setDocList(docArray);
          setDocListTemp(docArray);
        } else {
          setDocList(documentsList);
          setDocListTemp(documentsList);
        }
        orgFilterFlag
          ? dispatch(
              getTrainedData(new URLSearchParams(queryParams).get("name"))
            )
          : dispatch(
              getTrainedDataV2(new URLSearchParams(queryParams).get("name"))
            );
        dispatch(getChatHistoryV2(new URLSearchParams(queryParams).get("name"), userEmail))
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };

    fetchData();
  }, []);

  const tempDocList = history.location.state?.documents;

  useEffect(() => {
    const docArray = tempDocList;
    if (docArray == undefined) {
      if (docList?.length > 0) {
        docList?.splice(-1);
        setDocList(docList);
      }
      //history.push(`/collections?name=${collectionName}&c=${docCount}`);
    } else {
      if (docList?.length > 0) {
        setDocList((current) => [...current, docArray]);
      } else {
        setDocList(docArray);
      }
    }
  }, [tempDocList]);

  const addFile = async () => {
    setIsLoading(true);
    try {
      const result = await dispatch(
        getWalkthroughs(new URLSearchParams(queryParams).get("name"))
      );
      const documentsList = result?.message?.document_names;
      if (filePath?.length > 0) {
        const docFileTypeArray = uploadFileData?.name?.split(".");
        const fileName = uploadFileData?.name;
        const baseFileName = fileName.substring(0, fileName.lastIndexOf("."));
        const docFileType = docFileTypeArray[docFileTypeArray?.length - 1];
        const validFileTypes = [
          "pptx",
          "docx",
          "xlsx",
          "pdf",
          "pptx",
          "mp3",
          "mp4",
          "wav",
          "m4a",
          "mpeg",
          "flac",
          ".eml",
          ".msg"
        ];
        if (!orgFilterFlag) {
          if (/[&#;%]/.test(fileName)) {
            dispatch(
              notify(
                "error",
                "Special characters &, #, %, semicolon(;) are not allowed in the filename"
              )
            );
            setIsLoading(false);
            return;
          }
        } else {
        }

        if (docURL?.length > 0) {
          if (
            !(docURL.startsWith("http://") || docURL.startsWith("https://"))
          ) {
            dispatch(
              notify("error", "Please enter a valid Reference Document URL")
            );
            setIsLoading(false);
            return;
          }
        }
        if (!orgFilterFlag) {
          const baseFileNames = documentsList.map((doc) =>
            doc?.document_name.substring(0, doc?.document_name.lastIndexOf("."))
          );
          if (baseFileNames.includes(baseFileName)) {
            dispatch(
              notify(
                "error",
                "Filename already exist. Please remove the existing file and upload the new file or rename the new file."
              )
            );
            setIsLoading(false);
            return;
          }
        }

        if (validFileTypes.includes(docFileType)) {
          const fileSize = uploadFileData?.size;
          const fileMb = fileSize / 1024 / 1024;
          const fileLength = orgFilterFlag ? 255 : 64;
          if (uploadFileData?.name?.length <= fileLength) {
            let specificFileSizeLimit = 64;
            if(["mp3","mp4","wav","m4a","mpeg","flac"].includes(docFileType)){
              specificFileSizeLimit = 24;
            } else if(["xlsx"].includes(docFileType)){
              specificFileSizeLimit = 10;
            }
            if (fileMb <= specificFileSizeLimit) {

              //history.push(`/collections?name=${collectionName}&c=${docCount + 1}&doc=${fileName}`);
              if (!orgFilterFlag)
                docList.push({ document_name: fileName, status: "inprogress" });
              else docList.push(fileName);

              setLoading(true);
              setIsLoading(true);

              onSearch("");
              let createResponse;

              if (orgFilterFlag) {
                createResponse = await uploadDocument(
                  collectionName,
                  uploadFileData,
                  docURL
                );
              } else {
                if (ocrFlag == "false" && docFileType != "xlsx") {
                  dispatch(
                    notify(
                      "success",
                      "File uploading started. Status will be updated in some time. You can navigate away or upload a new file."
                    )
                  );

                  setLoading(false);
                  setIsLoading(false);
                  setFilePath("");
                  setDocURL("");
                  setUploadFileData([]);

                  createResponse = await uploadDocumentV2AzureService(
                    collectionName,
                    uploadFileData,
                    planType,
                    docURL,
                    ocrFlag
                  );

                  if (createResponse?.data?.status == "OK") {
                    dispatch(
                      notify("success", "Document uploaded successfully")
                    );
                    docList.pop();
                    docList.push({
                      document_name: fileName,
                      status: "success",
                    });
                    setDocList(docList);
                    setDocListTemp(docList);
                  } else {
                    dispatch(
                      notify("error", "Something went wrong. Please try again")
                    );
                  }
                } else {
                  dispatch(
                    notify(
                      "success",
                      "The file upload is in progress, and the status will be updated soon. You may navigate away or upload another file."
                    )
                  );
                  createResponse = await uploadDocumentV2(
                    collectionName,
                    uploadFileData,
                    planType,
                    docURL,
                    ocrFlag
                  );
                }
              }

              if (createResponse?.data == "OK") {
                let timer = setInterval(async () => {
                  const docUploadResponse = orgFilterFlag
                    ? await getDocUploadStatus(
                        uploadFileData?.name,
                        collectionName
                      )
                    : await getDocUploadStatusV2(
                        uploadFileData?.name,
                        collectionName,
                        planType
                      );

                  if (
                    !docUploadResponse?.status ||
                    docUploadResponse?.status == "NoRecord"
                  ) {
                    setLoading(false);
                    setIsLoading(false);
                    clearInterval(timer);
                    dispatch(
                      notify(
                        "error",
                        "Something went wrong, please refresh the page"
                      )
                    );
                    history.push(
                      `/collections?name=${collectionName}&c=${docCount}`
                    );
                  } else if (docUploadResponse?.status == "success") {
                    //docList.push(uploadFileData?.name);
                    if (!orgFilterFlag) {
                      docList.pop();
                      docList.push({
                        document_name: fileName,
                        status: "success",
                      });
                    }
                    setLoading(false);
                    setIsLoading(false);
                    clearInterval(timer);
                    setDocList(docList);
                    setDocListTemp(docList);
                    dispatch(
                      notify("success", "Document is vectorized and stored!")
                    );
                    setFilePath("");
                    setDocURL("");
                    setUploadFileData([]);
                  } else if (docUploadResponse?.status == "failed") {
                    if (!orgFilterFlag) {
                      docList.pop();
                      docList.push({
                        document_name: fileName,
                        status: "failed",
                      });
                    }
                    setLoading(false);
                    clearInterval(timer);
                    dispatch(notify("error", "Document upload failed"));
                    history.push(
                      `/collections?name=${collectionName}&c=${docCount}`
                    );
                  }
                }, 5000);
              } else {
                if (createResponse?.data?.status == "OK") {
                  dispatch(notify("success", "Document uploaded successfully"));
                } else {
                  dispatch(notify("error", createResponse?.data?.message));
                }
              }
            } else {
              setIsLoading(false);
              dispatch(
                notify(
                  "error",
                  `Please upload a file with size less than ${specificFileSizeLimit} MB`
                )
              );
            }
          } else {
            dispatch(
              notify(
                "error",
                `File name should be less than ${fileLength} characters`
              )
            );
          }
        } else {
          dispatch(
            notify(
              "error",
              "Please upload a valid file type: *.pptx, *.docx, *.xlsx, *.pdf "
            )
          );
          setIsLoading(false);
        }
      } else {
        dispatch(notify("error", "Please select a file to upload "));
        setIsLoading(false);
      }
    } catch (err) {
      dispatch(
        notify("error", "Something went wrong, please refresh the page")
      );
      setIsLoading(false);
      console.log("Error while retrieving", err.message);
    }
  };

  const handleOpenPicker = () => {
    window.gapi.load('client:auth2', () => {
      window.gapi.client
        .init({
          apiKey: process.env.REACT_APP_GOOGLE_DRIVE_API_KEY,
        })
        .then(() => {
          let tokenInfo = window.gapi.auth.getToken();
          const pickerConfig = {
            clientId: process.env.REACT_APP_GOOGLE_DRIVE_CLIENT_ID,
            developerKey: process.env.REACT_APP_GOOGLE_DRIVE_API_KEY,
            viewId: 'FOLDERS',
            viewMimeTypes: '.docx',
            token: tokenInfo ? tokenInfo.access_token : null,
            showUploadView: false,
            showUploadFolders: false,
            supportDrives: true,
            multiselect: true,
            setSelectFolderEnabled: true,
            callbackFunction: async (data) => {
              const elements = Array.from(
                document.getElementsByClassName('picker-dialog')
              );
              elements.forEach(element => {
                element.style.zIndex = '2000';
              });
              if (data.action === 'picked') {
                if (!tokenInfo) {
                  tokenInfo = window.gapi.auth.getToken();
                }
                const fetchOptions = {
                  headers: {
                    Authorization: `Bearer ${tokenInfo.access_token}`,
                  },
                };
                
                const validFileTypes = [
                  "xlsx",
                  "docx",
                  "pdf",
                  "pptx",
                  "mp3",
                  "mp4",
                  "wav",
                  "m4a",
                  "mpeg",
                  "flac",
                ];
                if (data.docs.length == 1 && data.docs[0].type === 'folder') {
                  if ( !fileTypes.length ) {
                    setLoading(false)
                    dispatch(
                      notify(
                        "error",
                        "Please select file types"
                      )
                    );
                    return
                  }
                  
                  try {
                    setDriveFolderSelected(true);
                    const folderId = data.docs[0].id;
                    setLoading(true)
                    const filesResponse = await fetch(`https://www.googleapis.com/drive/v3/files?q='${folderId}' in parents&key=a`, {
                        headers: {
                            Authorization: `Bearer ${tokenInfo.access_token}`,
                        },
                    });
                    const filesData = await filesResponse.json();
                    let files = filesData.files || [];
                    files = files.filter(fileName => fileTypes.includes(fileName.name.substring(fileName.name.lastIndexOf('.'))))
                    const fileDataInfo = files.map((file) => {
                      const fileExt = file.name.substring(file.name.lastIndexOf('.'))
                      if ((fileExt == 'xlsx') && (file?.sizeBytes / 1024 /1024) >= 10) {
                        throw new Error(`10`)
                      } else if (validFileTypes.slice(1,4).includes(fileExt) && (file?.sizeBytes / 1024 /1024) >= 64) {
                        throw new Error(`64`)
                      } else if (validFileTypes.slice(5).includes(fileExt) && (file?.sizeBytes / 1024 /1024) >= 24) {
                        throw new Error(`24`)
                      }
                      return {id:file.id,file_name:file.name}
                    })
                    const createResponse = await uploadGoogleDriveData(collectionName,planType,fileDataInfo,tokenInfo.access_token,"gdrive")
                    setLoading(false)
                    if (createResponse?.data?.status == "OK") {
                      dispatch(
                        notify("success",
                          "Your request is being processed and may take a few moments. Please revisit this page shortly to check the latest status."
                        )
                      );
                    //   const newDocList = createResponse.data.message.map(docName => ({
                    //     document_name: docName,
                    //     status: "success",
                    // }));
                    
                    // setDocList(newDocList);
                    // setDocListTemp(docList);
                    } else {
                      dispatch(
                        notify("error", "Something went wrong. Please try again")
                      );
                    }
                  } catch (error) {
                    setLoading(false)
                    if (error?.message) {
                      dispatch(
                        notify(
                          "error",
                          `Please upload files with size less than ${error.message} MB`
                        )
                      );
                    } else {
                      dispatch(
                        notify(
                          "error",
                          "Something went wrong, please refresh the page"
                        )
                      );
                    }
                  } 
                }
                else {
                  for (const file of data.docs) {
                    const fileExt = file.name.substring(file.name.lastIndexOf('.')+1)
                    if (!validFileTypes.includes(fileExt)) {
                      dispatch(
                        notify(
                          "error",
                          "Please upload a valid file type: *.pptx, *.docx, *.xlsx, *.pdf "
                        )
                      );
                      console.log("Files format is not supported please select .docx,xlsx,pptx,.pdf")
                      return
                    }
                    file.extension = fileExt
                  }
                  try {
                    setLoading(true)
                    const fileDataInfo = data.docs.map((file) => {
                      if ((file.extension == 'xlsx') && (file?.sizeBytes / 1024 /1024) >= 10) {
                        throw new Error(`10`)
                      } else if (validFileTypes.slice(1,4).includes(file.extension) && (file?.sizeBytes / 1024 /1024) >= 64) {
                        throw new Error(`64`)
                      } else if (validFileTypes.slice(5).includes(file.extension) && (file?.sizeBytes / 1024 /1024) >= 24) {
                        throw new Error(`24`)
                      }
                      return {id:file.id,file_name:file.name}
                    })
                    const createResponse = await uploadGoogleDriveData(collectionName,planType,fileDataInfo,tokenInfo.access_token,"gdrive")
                    setLoading(false)
                    if (createResponse?.data?.status == "OK") {
                      dispatch(
                        notify("success",
                          "Your request is being processed and may take a few moments. Please revisit this page shortly to check the latest status."
                        )
                      );
                    } else {
                      dispatch(
                        notify("error", "Something went wrong. Please try again")
                      );
                    }
                  } catch (error) {
                    setLoading(false)
                    if (error?.message) {
                      dispatch(
                        notify(
                          "error",
                          `Please upload files with size less than ${error.message} MB`
                        )
                      );
                    } else {
                      dispatch(
                        notify(
                          "error",
                          "Something went wrong, please refresh the page"
                        )
                      );
                    }
                  } 
                }
              }
            },
          };
          openPicker(pickerConfig);
        
        });
    });
  };

  const [isFolderModalOpen,setFolderModal] = useState(false)
  const [token, setToken] = useState('')
  const [folders, setFolders] = useState([]);
  const [folderId,setFolderId] = useState([])
  const [goBack, isGoBack] = useState(false)
  const [selectFolder, setSelectedFolders] = useState([])
  const [allFolders, setAllFolders] = useState([])
  
  const onSearchFile = (value, _e, info) => {
    let allfol;
    if (folderId.length) {
      allfol = allFolders.filter(id => folderId[folderId.length -1] in id)
      allfol = allfol[0][folderId[folderId.length -1]]

    } else {
      allfol = allFolders[0]['sites']
    }
      const filtered = allfol.filter(folder =>
        folder.name.toLowerCase().includes(value.toLowerCase()) || folder?.displayName?.toLowerCase()?.includes(value?.toLowerCase())
      );
      setFolders(prev => {
        if (prev.length == 1) {
          return [filtered]
        } else {
          const up = prev.slice(0,-1)
          return [...up,filtered]
        }
      })
  }

  const handleSelectFolderV2 = (data,isSet) => {
    if (!isSet) {
      if (selectFolder.some(obj => obj.id == data.id)) {
        setSelectedFolders(prev => prev.filter(obj => obj.id !== data.id));
        return
      } 
      if (data?.file) {
          setSelectedFolders(prev => [...prev,{id:data.id,url:data['@microsoft.graph.downloadUrl'],file_name:data.name,source_url:data.webUrl,size:data.size}])
      }
      else {
        setSelectedFolders(prev => [...prev,{id:data.id}])
      }
    } else {
      setFolderId(prev=>[...prev,data.id])
      setSelectedFolders([])
    }
  }

  useEffect(()=>{
    
    if (goBack){
        const allFiles = allFolders.filter(id => folderId[folderId.length -1] in id)
        if (allFiles.length){
          setFolders(prev => [...prev,allFiles[0][folderId[folderId.length -1]]])
        }
        else{
          setFolders(prev => [...prev,allFolders[0]['sites']])
        }
        isGoBack(false)
        return
    }
    if (folderId.length == 1) {
        showAllDrives()
        return
    }
    else if ( folderId.length == 2) {
        fetchDocuments(folderId[1])
    } else if ( folderId.length > 2 ) {
        fetchDocuments(folderId[1],folderId[folderId.length - 1])
    } 

  },[folderId])

  const handleBack = () => {
    isGoBack(true)
    setFolders(prev => {
      const newAr = prev.slice(0,-2);
      return newAr
    })
    setFolderId(prev => prev.slice(0,-1)) 
    setSelectedFolders([])
  }

  const fetchDocuments = async ( driveId,folderId) => {
    let response
    if (!folderId) {
        response = await fetch(`https://graph.microsoft.com/v1.0/drives/${driveId}/root/children`, {
          method: 'GET',
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
          },
      });
    }
    else {
      response = await fetch(`https://graph.microsoft.com/v1.0/drives/${driveId}/items/${folderId}/children`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
    }

    if (!response.ok) {
        throw new Error('Failed to fetch documents');
    }

    const data = await response.json();
    const newArray = data.value;
    setFolders(prev => [...prev,newArray]);
    setAllFolders(prev => [...prev, { [folderId ? folderId : driveId]: newArray }]);
    return data.value; 
  };

  const showAllDrives = async () => {
    if (token != '') {
        const response = await fetch(`https://graph.microsoft.com/v1.0/sites/${folderId[0]}/drives`, {
          headers: {
            Authorization:`Bearer ${token}`
          }
        })
        const data = await response.json();
        const drives = data.value
        setFolders(prev => [...prev,drives]);
        setAllFolders(prev => [...prev, { [folderId[0]]: drives }]);
    }
  }

  const fetchAllSitesV2 = async (accessToken) => {
    const response = await fetch('https://graph.microsoft.com/v1.0/sites?search=*', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  
    if (!response.ok) {
      throw new Error('Failed to fetch sites');
    }
  
    const data = await response.json();
    return data.value; 
  };

  const sendSelectedSharePointData = async () => {
    const validFileTypes = [
      "xlsx",
      "docx",
      "pdf",
      "pptx",
      "mp3",
      "mp4",
      "wav",
      "m4a",
      "mpeg",
      "flac",
    ]
    setFolderModal(false)
    if (selectFolder.length == 1 && !selectFolder[0]?.url) {
      if ( !fileTypes.length ) {
        setLoading(false)
        dispatch(
          notify(
            "error",
            "Please select file types"
          )
        );
        dummyShare()
        return
      }
      let files = await fetchDocuments(folderId[1],selectFolder[0].id)
      files = files.filter(fileName => fileTypes.includes(fileName.name.substring(fileName.name.lastIndexOf('.'))))
      for (const file of files) {
        const fileExt = file?.name?.substring(file.name.lastIndexOf('.')+1)
        if (!fileExt || !validFileTypes.includes(fileExt)) {
          dispatch(
            notify(
              "error",
              "Please upload a valid file type: *.pptx, *.docx, *.xlsx, *.pdf "
            )
          );
          console.log("Files format is not supported please select .docx,xlsx,pptx,.pdf")
          dummyShare()
          return
        }
        file.extension = fileExt
      }
      try {
        setDriveFolderSelected(true);
        setLoading(true)
        const fileDataArray = files.map((file) => {
          if ((file.extension == 'xlsx') && (file.size / 1024 /1024) >= 10) {
            throw new Error(`10`)
          } else if (validFileTypes.slice(1,4).includes(file.extension) && (file.size / 1024 /1024) >= 64) {
            throw new Error(`64`)
          } else if (validFileTypes.slice(5).includes(file.extension) && (file.size / 1024 /1024) >= 24) {
            throw new Error(`24`)
          }
          return { url: file['@microsoft.graph.downloadUrl'], file_name:file.name,source_url:file.webUrl };
        })
        const createResponse = await uploadSharepointData(collectionName,JSON.stringify(fileDataArray),"sharepoint",planType)
        setLoading(false)
        if (createResponse?.data?.status == "OK") {
          dispatch(
            notify("success",
              "Your request is being processed and may take a few moments. Please revisit this page shortly to check the latest status."
            )
          );
        } else {
          dispatch(
            notify("error", "Something went wrong. Please try again")
          );
        }
        setLoading(false)
      } catch (error) {
        setLoading(false)
        if (error?.message) {
          dispatch(
            notify(
              "error",
              `Please upload files with size less than ${error.message} MB`
            )
          );
        } else {
          dispatch(
            notify(
              "error",
              "Something went wrong, please refresh the page"
            )
          );
        }
      }
      
    } else {
      for (const file of selectFolder) {
        const fileExt = file?.file_name?.substring(file.file_name.lastIndexOf('.')+1)
        if (!fileExt || !validFileTypes.includes(fileExt)) {
          dispatch(
            notify(
              "error",
              "Please upload a valid file type: *.pptx, *.docx, *.xlsx, *.pdf "
            )
          );
          console.log("Files format is not supported please select .docx,xlsx,pptx,.pdf")
          dummyShare()
          return
        }
        file.extension = fileExt
      }
      try {
        setDriveFolderSelected(false);
        setLoading(true)
        const fileDataArray = selectFolder.map((file) => {
          if ((file.extension == 'xlsx') && (file.size / 1024 /1024) >= 10) {
            throw new Error(`10`)
          } else if (validFileTypes.slice(1,4).includes(file.extension) && (file.size / 1024 /1024) >= 64) {
            throw new Error(`64`)
          } else if (validFileTypes.slice(5).includes(file.extension) && (file.size / 1024 /1024) >= 24) {
            throw new Error(`24`)
          }
          return { url: file.url, file_name:file.file_name,source_url:file.source_url };
        })
        console.log(fileDataArray)
        const createResponse = await uploadSharepointData(collectionName,JSON.stringify(fileDataArray),"sharepoint",planType)
        setLoading(false)
        if (createResponse?.data?.status == "OK") {
          dispatch(
            notify("success",
              "Your request is being processed and may take a few moments. Please revisit this page shortly to check the latest status."
            )
          );
        } else {
          dispatch(
            notify("error", "Something went wrong. Please try again")
          );
        }
        setLoading(false)
      } catch (error) {
        setLoading(false)
        if (error?.message) {
          dispatch(
            notify(
              "error",
              `Please upload files with size less than ${error.message} MB`
            )
          );
        } else {
          dispatch(
            notify(
              "error",
              "Something went wrong, please refresh the page"
            )
          );
        }
      }
    }
    setDriveFolderSelected(true);
    dummyShare()
  }

  const dummyShare = () => {
    setFolderModal(false)
    setFolderId([])
    setFolders([])
    setSelectedFolders([])
    setLoading(false)
  }

  const handleSharePoint = async () => {
    try {
      const tokenResponse = await msalInstance.loginPopup({
        scopes: ['Files.Read', 'Sites.Read.All']
      });
      const accessToken = tokenResponse.accessToken;
      setToken(accessToken)
      setLoading(true)
      const resp_sites = await fetchAllSitesV2(accessToken)
      setFolders(prev => [...prev,resp_sites])
      setAllFolders(prev => [...prev, { 'sites': resp_sites }]);
      setFolderModal(true)
    } catch (error) {
      console.error('Error selecting files:', error);
    }
  }

  const sendSharepointData = async () => {
    uploadSharepointData(
      collectionName,
      clientID,
      clientSecretID,
      tenantID,
      uploadSiteName,
      sharePointSiteID,
      folderPath,
      fileTypes,
      "sharepoint",
      planType
    );

    setClientID("");
    setClientSecretID("");
    setTenantID("");
    setUploadSiteName("");
    setSharePointSiteID("");
    setFolderPath("");
    setFileTypes("");
    setUploadFileData("");
    setFileTypeDefault([]);

    dispatch(
      notify(
        "success",
        "The file upload is in progress, and the status will be updated soon. You may navigate away or upload another file."
      )
    );
  };

  const sendGoogleDriveData = async () => {
    uploadGoogleDriveData(
      collectionName,
      folderPath,
      uploadFileData,
      fileTypes,
      "googledrive",
      planType
    );

    setClientID("");
    setClientSecretID("");
    setTenantID("");
    setUploadSiteName("");
    setSharePointSiteID("");
    setFolderPath("");
    setFileTypes("");
    setUploadFileData("");
    setFilePath("");
    setFileTypeDefault([]);

    dispatch(
      notify(
        "success",
        "The file upload is in progress, and the status will be updated soon. You may navigate away or upload another file."
      )
    );
  };

  const addURL = async () => {
    if (
      !(
        uploadURLText.startsWith("http://") ||
        uploadURLText.startsWith("https://")
      )
    ) {
      dispatch(notify("error", "Please enter a valid URL"));
      return;
    }
    if (resourceName?.length < 1) {
      dispatch(notify("error", "Please enter a valid Resource name"));
      return;
    }

    //history.push(`/collections?name=${collectionName}&c=${docCount + 1}&doc=${resourceName}`);
    const result = await dispatch(
      getWalkthroughs(new URLSearchParams(queryParams).get("name"))
    );
    const documentsList = result?.message?.document_names;
    const isContains = documentsList.some(document => document.document_name == resourceName)
    if (isContains) {
      dispatch(
        notify(
          "error",
          "Filename already exist. Please remove the existing file and upload the new file or rename the new file."
        )
      );
      return;
    }
    let createResponse;
    if (orgFilterFlag) {
      docList.push(resourceName);
      setLoading(true);
      onSearch("");
      createResponse = await uploadUrl(
        collectionName,
        uploadURLText,
        resourceName
      );
    } else {
      docList.push({ document_name: resourceName, status: "inprogress" });
      setLoading(true);
      onSearch("");
      createResponse = await uploadUrlV2(
        collectionName,
        uploadURLText,
        resourceName,
        planType,
        valueScrape
      );
    }
    setLoading(false);

    if (createResponse?.data?.status == "OK") {
      valueScrape == 2 ? dispatch(
        notify("success",
          "Your request is being processed and may take a few moments. Please revisit this page shortly to check the latest status."
        )
      ) :
      dispatch(notify("success", "The URL has been vectorised and stored."));
      if (orgFilterFlag) {
        setDocList(docList);
        setDocListTemp(docList);
      } else {
        docList.pop();
        docList.push({ document_name: resourceName, status: "success" });
        setDocList(docList);
        setDocListTemp(docList);
      }
      setUploadURLText("");
      setResourceName("");
    } else {
      dispatch(
        notify("error", "Something went wrong, please refresh the page")
      );
    }
  };

  const uploadText = async () => {

    if (resourceName?.length < 1) {
      dispatch(notify("error", "Please enter a valid Resource name"));
      return;
    }

    if (textValue?.length < 1) {
      dispatch(notify("error", "The text field should NOT be empty"));
      return;
    }

    let fileType = "text";
    let userType;

    if (groupPlan?.planId === 4) {
      userType = "team";
    } else if (groupPlan?.planId === 5) {
      userType = "business";
    } else {
      userType = "pro";
    }

    let uploadTextResponse;
    docList.push({ document_name: resourceName, status: "inprogress" });
    setDocList([...docList]);
    setLoading(true);
    try {
      uploadTextResponse = await uploadTextV2(
        collectionName,
        fileType,
        textValue,
        resourceName,
        userType
      );
    } catch (error) {
      console.error("Upload failed:", error);
      setLoading(false);
      setIsLoading(false);
      dispatch(notify("error", "Something went wrong during upload"));
      return;
    }

    setLoading(false);
    setIsLoading(false);

    if (uploadTextResponse?.data?.status === "OK") {
      await dispatch(
        getWalkthroughs(new URLSearchParams(queryParams).get("name"))
      );
      const updatedDocList = docList.map((doc) =>
        doc.document_name === resourceName ? { ...doc, status: "success" } : doc
      );
      setDocList(updatedDocList);
      setDocListTemp(updatedDocList);
      setResourceName("");
      setTextValue("");
      dispatch(notify("success", "Text uploaded successfully."));
    } else {
      // const updatedDocList = docList.map((doc) =>
      //   doc.document_name === resourceName ? { ...doc, status: "failed" } : doc
      // );
      const updatedDocList = docList.slice(0,-1);
      setDocList(updatedDocList);
      setDocListTemp(updatedDocList);

      dispatch(notify("error", uploadTextResponse?.data?.message));
      setResourceName("");
      setTextValue("");
    }
  };

  const updateText = async () => {
    let fileType = "text";
    let userType;

    if (groupPlan?.planId === 4) {
      userType = "team";
    } else if (groupPlan?.planId === 5) {
      userType = "business";
    } else {
      userType = "pro";
    }

    let uploadTextResponse;

    // Find the existing document and update its status to "inprogress"
    const updatedDocList = docList.map((doc) =>
      doc.document_name === resourceName
        ? { ...doc, status: "inprogress" }
        : doc
    );

    setDocList(updatedDocList);
    setLoading(true);
    try {
      uploadTextResponse = await updateTextV2(
        collectionName,
        fileType,
        updatedTextValue,
        existingResourceName,
        userType
      );
    } catch (error) {
      console.error("Upload failed:", error);
      setLoading(false);
      setIsLoading(false);
      dispatch(notify("error", "Something went wrong during upload"));
      return;
    }

    setLoading(false);
    setIsLoading(false);

    if (uploadTextResponse?.data?.status === "OK") {
      // Update the status to "success" for the specific document
      const finalDocList = docList.map((doc) =>
        doc.document_name === resourceName ? { ...doc, status: "success" } : doc
      );
      setDocList(finalDocList);
      setDocListTemp(finalDocList);
      dispatch(notify("success", "Text uploaded successfully."));
    } else {
      // Update the status to "failed" for the specific document
      const finalDocList = docList.map((doc) =>
        doc.document_name === resourceName ? { ...doc, status: "failed" } : doc
      );
      setDocList(finalDocList);
      setDocListTemp(finalDocList);
      dispatch(notify("error", "Something went wrong"));
    }

    // Clear the input fields after update
    setUpdatedTextValue("");
  };

  const { Search } = Input;
  const onSearch = async (value) => {
    const filteredDocList = orgFilterFlag
      ? docListTemp.filter((s) => s.toLowerCase().match(value.toLowerCase()))
      : docListTemp.filter((s) =>
          s?.document_name.toLowerCase().match(value.toLowerCase())
        );
    setDocList(filteredDocList);
    setDocSelected("");
  };
  const onSearchWalkthroughs = async (value) => {
    let filter = "SKILL_NAME";
    let filteredData = walkthroughsListTemp.filter(function (obj) {
      return obj[filter]?.toLowerCase().match(value.toLowerCase());
    });
    _setWalkthroughsList(filteredData);
  };

  const onDocumentURLClick = async (value) => {
    setDocURL(value);
  };

  const { TextArea } = Input;
  const [editAnswerValue, setEditAnswerValue] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAnswerNew, setIsAnswerNew] = useState(false);
  const [isAnswerOld, setIsAnswerOld] = useState(false);
  const [editQuestionID, setEditQuestionID] = useState("");
  const [editQuestionText, setEditQuestionText] = useState("");
  const [editAnswerOldText, setEditAnswerOldText] = useState("");

  const handleOk = () => {
    setIsModalOpen(false);
    setLoading(true);
    if (orgFilterFlag) {
      dispatch(
        deleteTrainedData(collectionName, editQuestionID, editQuestionText)
      ).then(() => {
        sendInputAnswer(
          collectionName,
          editQuestionID,
          editQuestionText,
          editAnswerOldText,
          editAnswerValue
        ).then(() => {
          dispatch(notify("success", "Updated answer successfully"));
          dispatch(getTrainedData(collectionName));
          setLoading(false);
        });
      });
    } else {
      dispatch(
        deleteTrainedDataV2(
          collectionName,
          editQuestionID,
          editQuestionText,
          planType
        )
      ).then(() => {
        sendInputAnswerV2(
          collectionName,
          editQuestionID,
          editQuestionText,
          editAnswerOldText,
          editAnswerValue,
          planType
        ).then(() => {
          dispatch(notify("success", "Updated answer successfully"));
          dispatch(getTrainedDataV2(collectionName));
          setLoading(false);
        });
      });
    }
  };

  const handleCancel = () => {
    setEditAnswerValue("");
    setIsModalOpen(false);
  };

  const showModalOldAnswer = (text) => {
    setIsAnswerOld(true);
    setOldAnswerText(text);
  };
  const handleOkOld = () => {
    setIsAnswerOld(false);
  };
  const handleCancelOld = () => {
    setIsAnswerOld(false);
  };

  const showModalNewAnswer = (text) => {
    setIsAnswerNew(true);
    setNewAnswerText(text);
  };
  const showModalEditAnswer = (record) => {
    setIsModalOpen(true);
    setEditQuestionID(record.id);
    setEditQuestionText(record.question);
    setEditAnswerOldText(record.new_answer);
    setEditAnswerValue(record.new_answer);
  };
  const handleOkNew = () => {
    setIsAnswerNew(false);
  };
  const handleCancelNew = () => {
    setIsAnswerNew(false);
  };

  const { confirm } = Modal;

  const showDeleteConfirm = (record) => {
    confirm({
      title: "Are you sure delete this row?",
      icon: <ExclamationCircleFilled />,
      // content: 'Some descriptions',
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        deleteUploadedAnswer(record);
      },
      onCancel() {},
    });
  };

  const columns = [
    {
      title: "Question",
      dataIndex: "question",
      key: "question",
      render: (text) => <p className="tb-question">{text}</p>,
      width: "35%",
    },
    {
      title: "Old Answer",
      dataIndex: "answer",
      key: "answer",
      render: (text) => (
        <Space size="middle">
          <Button
            type="default"
            onClick={() => {
              showModalOldAnswer(text);
            }}
          >
            View Answer
          </Button>
        </Space>
      ),
    },
    {
      title: "Updated Answer",
      dataIndex: "new_answer",
      key: "new_answer",
      render: (text) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => {
              showModalNewAnswer(text);
            }}
          >
            View Answer
          </Button>
        </Space>
      ),
    },
    {
      title: "Updated By",
      key: "updated_by",
      dataIndex: "updated_by",
      render: (text) => (
        <Tag color="geekblue" key={text}>
          {text}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "id",
      render: (record) => (
        <Space size="middle" style={{ gap: "6px" }}>
          <Tooltip title="Edit Answer">
            <Button
              type="primary"
              shape="circle"
              icon={<EditOutlined />}
              onClick={() => showModalEditAnswer(record)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              type="danger"
              shape="circle"
              icon={<DeleteOutlined />}
              onClick={() => showDeleteConfirm(record)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const textDataLookup = collectionDocs?.reduce((acc, doc) => {
    acc[doc.document_name] = Boolean(doc.text_data);
    return acc;
  }, {});

  const uploadFiles = () => {
    return (
      <>
        <div className="csd-search-bar">
          <Input
            placeholder="Search Document"
            onChange={(e) => onSearch(e.target.value)}
          />
        </div>
        {docList?.length > 0
          ? docList.map((obj, ind) => {
              if (obj?.document_name?.length > 0) {
                return (
                  <div
                    className="tl-block"
                    onClick={(e) => {
                      if (obj?.status == "success") {
                        setDocSelected(obj?.document_name);
                        if ($(".tl-block").hasClass("active")) {
                          $(e.target).removeClass("active");
                          $(e.target?.parentNode?.parentNode).removeClass(
                            "active"
                          );
                        } else {
                          $(e.target).addClass("active");
                          $(e.target?.parentNode?.parentNode).addClass(
                            "active"
                          );
                        }

                        if ($(".tl-block").hasClass("active")) {
                          $(".tl-block").removeClass("active");
                          $(e.target).addClass("active");
                          $(e.target?.parentNode?.parentNode).addClass(
                            "active"
                          );
                        }
                      }
                    }}
                  >
                    {obj?.status !== "inprogress" ? (
                      <>
                        <CheckCircleOutlined style={{ color: "#fff" }} />
                        {textDataLookup[obj.document_name] ? (
                          <Tooltip title="Edit Text">
                            <EditTwoTone
                              twoToneColor="#4535C1"
                              className="csd-edit-text"
                              onClick={() => handleEditClick(obj)}
                            />
                          </Tooltip>
                        ) : null}
                        <div
                          data-toggle="modal"
                          data-target="#documentDeleteModal"
                        >
                          {userDetails?.role_id === "2" ? (
                            <>
                              <Tooltip
                                title="Delete File"
                                onClick={() => {
                                  setDocSelected(obj?.document_name);
                                }}
                              >
                                <DeleteTwoTone
                                  className="csd-delete-file"
                                  twoToneColor="#fd2000"
                                />
                              </Tooltip>
                            </>
                          ) : null}
                        </div>
                      </>
                    ) : null}

                    <div className="tl-icon">
                      <div className="cts-avatar">
                        {textDataLookup[obj.document_name] ? (
                          <img src={textIcon} alt="Text Icon" />
                        ) : /\.[^/.]+$/.test(obj?.document_name) ? (
                          <img src={fileIcon} alt="File Icon" />
                        ) : (
                          <img src={urlIcon} alt="URL Icon" />
                        )}
                      </div>
                    </div>

                    <div className="tl-cont">
                      <p title={obj?.document_name}>
                        {obj?.document_name?.length > 50
                          ? `${obj?.document_name.substring(0, 50)}...`
                          : obj?.document_name}
                      </p>
                      {loading && ind === docList?.length - 1 ? (
                        <span>inprogress</span>
                      ) : (
                        <span>{obj?.status}</span>
                      )}
                    </div>
                  </div>
                );
              }
            })
          : null}
      </>
    );
  };

  const uploadFilesV1 = () => {
    return (
      <>
        <div className="csd-search-bar">
          <Input
            placeholder="Search Document"
            onChange={(e) => onSearch(e.target.value)}
          />
        </div>
        {docList?.length > 0
          ? docList.map((obj, ind) => {
              if (obj?.length > 0) {
                return (
                  <div
                    className="tl-block"
                    onClick={(e) => {
                      setDocSelected(obj);
                      if ($(".tl-block").hasClass("active")) {
                        $(e.target).removeClass("active");
                        $(e.target?.parentNode?.parentNode).removeClass(
                          "active"
                        );
                      } else {
                        $(e.target).addClass("active");
                        $(e.target?.parentNode?.parentNode).addClass("active");
                      }

                      if ($(".tl-block").hasClass("active")) {
                        $(".tl-block").removeClass("active");
                        $(e.target).addClass("active");
                        $(e.target?.parentNode?.parentNode).addClass("active");
                      }
                    }}
                  >
                    <div data-toggle="modal" data-target="#documentDeleteModal">
                      <CheckCircleOutlined style={{ color: "#fff" }} />
                      {userDetails?.role_id == "2" ? (
                        <>
                          <Tooltip
                            title="Delete File"
                            onClick={() => {
                              setDocSelected(obj);
                            }}
                          >
                            <DeleteTwoTone
                              className="csd-delete-file"
                              twoToneColor="#fd2000"
                            />
                          </Tooltip>
                        </>
                      ) : null}
                    </div>
                    <div className="tl-icon">
                      <div className="cts-avatar">
                        <img src={fileIcon} alt="" />
                      </div>
                    </div>
                    <div className="tl-cont">
                      <p title={obj}>
                        {obj?.length > 50 ? `${obj?.substring(0, 50)}...` : obj}
                      </p>
                      {loading && ind === docList?.length - 1 ? (
                        <span>inprogress</span>
                      ) : (
                        <span>uploaded</span>
                      )}
                    </div>
                  </div>
                );
              }
            })
          : null}
      </>
    );
  };

  const handleSave = async () => {
    try {
      let result = await uploadInstructionV2(collectionName, instruction);
      if (result?.status === 200) {
        await dispatch(
          getWalkthroughs(new URLSearchParams(queryParams).get("name"))
        );
        dispatch(notify("success", "Instruction saved successfully."));
      } else {
        dispatch(notify("error", "Instruction update failed."));
      }
    } catch (e) {
      dispatch(notify("error", "Something went wrong. Please try again"));
    }
  };

  const additionalInstructions = () => {
    return (
      <>
        <div className="csd-search-bar">
          <TextArea
            value={instruction == " " ? setInstruction("") : instruction}
            onChange={(e) => setInstruction(e.target.value)}
            placeholder="Type your message here"
            autoSize={{
              minRows: 5,
            }}
          />
          <Button type="primary" onClick={handleSave}>
            Save
          </Button>
        </div>
      </>
    );
  };
  const getAvailableSkills = async () => {
    let data = { page: -1 };
    const userDraftSkill = await dispatch(getDraftSkills(data));

    let inAppWalkthroughSkills = userDraftSkill?.results?.filter(
      (skill) => skill.TEMPLATE === "In-App Walkthrough"
    );

    let inAppWalkthroughSkillsFiltered = inAppWalkthroughSkills.filter((el) => {
      return !_walkthroughsList.find((element) => {
        return element.id === el.id;
      });
    });

    if (inAppWalkthroughSkillsFiltered.length > 0) {
      let inAppWalkthroughDataArray = inAppWalkthroughSkillsFiltered?.map(
        (r) => ({
          label: r.SKILL_NAME,
          value: r.id,
          SKILL_NAME: r.SKILL_NAME,
          id: r.id,
          SKILL_DESCRIPTION: r.SKILL_DESCRIPTION,
          TEMPLATE: r.TEMPLATE,
          TYPE: r.TYPE,
          USER_EMAIL: r.USER_EMAIL,
          organizationId: r.organizationId,
          revision: r.revision,
          status: r.status,
          updated_at: r.updated_at,
        })
      );

      setInAppWalkthroughData(inAppWalkthroughDataArray);
    }
  };

  const deleteWalkthrough = async () => {
    try {
      let walkthroughsPayload = _walkthroughsList.filter(function (obj) {
        return obj.id !== walkthroughToDelete;
      });

      let walkthroughResponse = await dispatch(
        updateWalkthroughs(
          new URLSearchParams(queryParams).get("name"),
          walkthroughsPayload
        )
      );

      if (walkthroughResponse?.status == 200) {
        dispatch(notify("success", "Walkthrough successfully deleted"));
        _setWalkthroughsList(walkthroughsPayload);
        onSearch("");
        dispatch(getWalkthroughs(new URLSearchParams(queryParams).get("name")));
        setWalkthroughFlag(false);
      } else {
        dispatch(
          notify("error", "Walkthrough deletion failed. Please try again.")
        );
      }
    } catch {
      dispatch(notify("error", "Something went wrong. Please try again."));
    }
  };

  const callbackTabClicked = async (key, event) => {
    if (key === "2" || key === "3") {
      await dispatch(
        getWalkthroughs(new URLSearchParams(queryParams).get("name"))
      );
    }
  };

  const listWalkthrough = [
    {
      value: "Download WordPress - Step 2",
    },
    {
      value: "How to Publish a Post",
    },
    {
      value: "How to Edit and Moderate Comments",
    },
  ];

  const WalkthroughList = () => {
    return (
      <>
        <div className="walk-list">
          <div className="csd-search-bar flex-search-btn">
            <Input
              placeholder="Search Walkthroughs"
              onChange={(e) => onSearchWalkthroughs(e.target.value)}
            />
            <Tooltip placement="bottom" title="Attach Walkthroughs">
              <Button
                onClick={() => {
                  walkthroughFlag
                    ? setWalkthroughFlag(false)
                    : setWalkthroughFlag(true);
                  getAvailableSkills();
                }}
                type="primary"
                icon={<PlusOutlined />}
              ></Button>
            </Tooltip>
          </div>

          {walkthroughFlag ? (
            <div className="attach-wlk-block">
              <Select
                mode="multiple"
                allowClear
                placeholder="Search Walkthroughs"
                style={{
                  width: "100%",
                }}
                options={inAppWalkthroughData}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onChange={onWalkThroughSelectionChange}
              />
              <Button onClick={() => saveWalkthrough()} type="primary">
                Save
              </Button>
            </div>
          ) : null}

          {_walkthroughsList?.length > 0
            ? _walkthroughsList.map((obj, ind) => {
                return (
                  <div
                    className="tl-block"
                    onClick={(e) => {
                      //setDocSelected(obj);
                      if ($(".tl-block").hasClass("active")) {
                        $(e.target).removeClass("active");
                        $(e.target?.parentNode?.parentNode).removeClass(
                          "active"
                        );
                      } else {
                        $(e.target).addClass("active");
                        $(e.target?.parentNode?.parentNode).addClass("active");
                      }

                      if ($(".tl-block").hasClass("active")) {
                        $(".tl-block").removeClass("active");
                        $(e.target).addClass("active");
                        $(e.target?.parentNode?.parentNode).addClass("active");
                      }
                    }}
                  >
                    <div
                      data-toggle="modal"
                      data-target="#walkthroughDeleteModal"
                    >
                      <CheckCircleOutlined style={{ color: "#fff" }} />
                      {userDetails?.role_id == "2" ? (
                        <>
                          <Tooltip
                            title="Delete Walkthrough"
                            onClick={() => {
                              setWalkthroughToDelete(obj?.id);
                            }}
                          >
                            <DeleteTwoTone
                              className="csd-delete-file"
                              twoToneColor="#fd2000"
                            />
                          </Tooltip>
                        </>
                      ) : null}
                    </div>
                    <div className="tl-icon">
                      <div className="cts-avatar-wlk">
                        <img src={fileIcon} alt="" />
                      </div>
                    </div>
                    <div className="tl-cont">
                      <p title={obj?.SKILL_NAME}>{obj?.SKILL_NAME}</p>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      </>
    );
  };

  const items = orgFilterFlag
    ? [
        {
          key: "1",
          label: "Uploaded Files",
          children: uploadFilesV1(),
        },
      ]
    : [
        {
          key: "1",
          label: "Uploaded Files",
          children: uploadFiles(),
        },
        {
          key: "2",
          label: "Walkthroughs",
          children: WalkthroughList(),
        },
        {
          key: "3",
          label: "Additional Instructions",
          children: additionalInstructions(),
        },
      ];

  const userDeviceId = useSelector((state) => state.skillReducer.draftSession);

  const executeSkill = async (skill) => {
    let data = {
      deviceId: userDeviceId,
      skillId: skill?.id,
      bulk: false,
      restoreChrome: true,
    };
    if (userDeviceId) {
      await dispatch(executeFlow(data));
    } else {
      dispatch(
        notify(
          "error",
          "You are not connected to Super Assistant. Please install Super Assistant app."
        )
      );
    }
  };

  useEffect(() => {
    $(".bottom-fix-sd-btn button").on("click", function () {
      $(".collection-sidebar").removeClass("active");
      $(".fixed-bar").removeClass("active");
      $(".sidebar-global").removeClass("active");
    });
    $(".drawer-close-btn").on("click", function () {
      $(".collection-sidebar").removeClass("active");
      $(".fixed-bar").removeClass("active");
      $(".sidebar-global").removeClass("active");
    });
  });

  const uploadRef = useRef(null);
  const handleButtonClick = (e) => {
    uploadRef.current?.upload?.uploader?.onClick(e);
  };

  const chsItems = [
    {
      label: <a href="https://www.aliyun.com">2nd menu item</a>,
      key: "1",
    },
    {
      type: "divider",
    },
    {
      label: "3rd menu item",
      key: "3",
    },
  ];

  const onOpenChatHistory = (item) => {
    {
      setQueryData([]);

      const query = (
        <div className="mac-chat mac-right">
          <div className="mac-text">
            <p className="mac-black">{item.question}</p>
          </div>
          <div className="mac-avt">
            <img src={avatarIcon} alt="" />
          </div>
        </div>
      );
      setQueryData((current) => [query, ...current]);

      if (item.question?.length > 0) {
        let htmlResponseParsed = marked(item.answer);
        htmlResponseParsed = htmlResponseParsed.replaceAll(
          "href=",
          'target="_blank" href='
        );

        const queryTemp = (
          <div className="mac-chat mac-left">
            <div className="mac-avt">
              <img src={systemIcon} alt="" />
            </div>
            <div className="mac-text">
              {/* Play Text  */}
              <div className="mac-icon-select">
                {/* Select Language */}
                {/* <Tooltip title="Select Voice Language">
                  <Select
                    defaultValue={
                      selectedVoiceRef?.current?.length
                        ? selectedVoiceRef?.current == "hi-IN-AditiNeural"
                          ? "हिन्दी"
                          : "English"
                        : voicesRef.current[0].name == "Google हिन्दी"
                        ? "हिन्दी"
                        : "English"
                    }
                    style={{
                      width: 150,
                    }}
                    onChange={handleUpdateVoice}
                    placeholder="Select Language"
                  >
                    <Option>
                      <Option value="en-US-David">English"</Option>

                      <Option value="hi-IN-AditiNeural">"हिन्दी"</Option>
                    </Option>
                  </Select>
                </Tooltip> */}

                {/*
                <div className="mac-icon-click">
                  <Tooltip title="Read aloud">
                    <button
                      onClick={() => {
                        speechRef.current = item.answer;
                        handlePlay();
                      }}
                      className={"m-chat-play"}
                    >
                      <PlayCircleOutlined className="play-icon" />
                    </button>
                  </Tooltip>
                  <Tooltip title="Stop audio">
                    <button
                      onClick={() => {
                        speechRef.current = item.answer;
                        handlePause();
                      }}
                      className={"m-chat-play active"}
                    >
                      <PauseCircleOutlined className="pause-icon" />
                    </button>
                  </Tooltip>
                </div>
*/}
              </div>
              <p
                className="mac-white"
                dangerouslySetInnerHTML={{ __html: htmlResponseParsed }}
              ></p>

              {/* <span className="suggestion">If the given answer doesn't help, press <i className="fa fa-thumbs-down inline-thumb" /> to search from public knowledge (may not be accurate).</span> */}
              <div className="thumbs-action mac-text-thumbs">
                <i
                  className="fa fa-thumbs-up"
                  onClick={() => {
                    setLiked(true);
                  }}
                ></i>
                <i
                  className="fa fa-thumbs-down"
                  onClick={() => {
                    setDisliked(true);
                  }}
                ></i>
              </div>
            </div>
          </div>
        );
        setQueryData((current) => [queryTemp, ...current]);
      }
    }
  };

  let chatHistoryList =
    _chatHistoryList?.length > 0 && _chatHistoryList != "No data found "
      ? _chatHistoryList?.map((item, index) => (
          <div className="ch-list-item" key={index}>
            <div
              className="ch-list-item-inner"
              onClick={() => {
                onOpenChatHistory(item);
              }}
            >
              <p>{item.question}</p>
            </div>
            {/* <Tooltip title="Delete">
                            <DeleteTwoTone
                              className="csd-delete-file"
                              twoToneColor="#fd2000"
                            />
                            </Tooltip> */}
          </div>
        ))
      : [];

  const optionsWithDisabled = [
    {
      label: "Local Drive",
      value: "local_upload",
    },
    {
      label: "Sharepoint",
      value: "sharepoint",
    },
    {
      label: "Google Drive",
      value: "google_drive",
    },
  ];

  const [fileTypeDefault, setFileTypeDefault] = useState([]);

  const handleChangeFileType = (value) => {
    setFileTypeDefault(value);
    let fileTypesList = `["${value}"]`;
    fileTypesList = fileTypesList.replaceAll(",", `","`);
    setFileTypes(fileTypesList);
  };

  const [valueScrape, setValueScrape] = useState(1);
  const onChangeScrape = (e) => {
    setValueScrape(e.target.value);
  };

  const siteName = (
    <div className="pop-uploadcontent">
      <ul>
        <li>
          <p>
            {" "}
            - Site Name can be found in your sharepoint site directory in the
            browser URL:
          </p>
          <a>{`https://<ORG>.sharepoint.com/sites/<SITE_NAME>`}</a>
        </li>
      </ul>
    </div>
  );
  const folderName = (
    <div className="pop-uploadcontent">
      <ul>
        <li>
          <p>
            {" "}
            - Folder Name should be from one of the folder names in the
            Documents Directory inside a SharePoint Site
          </p>
        </li>
      </ul>
    </div>
  );
  const siteID = (
    <div className="pop-uploadcontent">
      <ul>
        <li>
          <p>
            {" "}
            - Visit this URL -{" "}
            <a>https://developer.microsoft.com/en-us/graph/graph-explorer</a>
          </p>
          <p>
            {" "}
            - Execute in input box -{" "}
            <a>https://graph.microsoft.com/v1.0/sites/root</a>
          </p>
          <p> - Then site id will be found as the value of key "id"</p>
        </li>
      </ul>
    </div>
  );
  const clientTenantId = (
    <div className="pop-uploadcontent">
      <ul>
        <li>
          <p>
            {" "}
            - To get Client ID and Tenant ID go to Azure Portal, in the left
            panel look for "Azure Active Directory"
          </p>
          <p>
            {" "}
            - Then go to App Registrations, click on Owned Applications, select
            the App to be used to RAG SharePoint
          </p>
          <p>
            {" "}
            - Client ID and Tenant ID will be present, copy and paste them here
          </p>
        </li>
      </ul>
    </div>
  );

  const clientSecret = (
    <div className="pop-uploadcontent">
      <ul>
        <li>
          <p> - Then Click on "Certificates & secrets" in that App</p>
          <p> - Under Client secrets, click New client secret</p>
          <p> - Enter a name and an expiration date and click Add</p>
          <p> - Copy and paste the value of "Client Secret" here</p>
        </li>
      </ul>
    </div>
  );

  const folderIdG = (
    <div className="pop-uploadcontent">
      <ul>
        <li>
          <p>
            {" "}
            - Folder ID can be found by right clicking on folder name, copy the
            shareable link
          </p>
          <p>
            {" "}
            - The link will look like this:{" "}
            <a>
              https://drive.google.com/drive/folders/
              <i>
                <b>1SLZO6JhRhb1xrvTxv1hlacx52lXVwJ_b</b>
              </i>
              ?usp=drive_link
            </a>
          </p>
          <p> - The italic text is the FOLDER ID, copy and paste it here.</p>
        </li>
      </ul>
    </div>
  );

  const tokenG = (
    <div className="pop-uploadcontent">
      <ul>
        <li>
          <p>
            {" "}
            - Follow this guide to generate Credentials.json File:-
            <a>
              https://developers.google.com/workspace/guides/create-credentials{" "}
            </a>
          </p>
          <p>
            {" "}
            - Download the Token File from this link:-
            <a>
              https://drive.google.com/file/d/1-v9OWV6HyzGvWrnsbIUss0_iPEvLa3WE/view?usp=sharing{" "}
            </a>
          </p>
          <p>
            {" "}
            - Install the libraries and execute the code as mentioned in the
            file comments{" "}
          </p>
          <p> - This will save a token.json file, import that file here </p>
        </li>
      </ul>
    </div>
  );

  return (
    <div className="flex-custom-sd">
      <div
        className={
          minMode
            ? "task-list collection-sidebar active"
            : "task-list collection-sidebar"
        }
      >
        {/* <div className="task-list collection-sidebar"> */}
        <div className="sd-empty-list" style={{ display: "none" }}>
          <img src={emptyIcon} />
          <h4>No Data found</h4>
          <p>
            Please select the option from the right block to add the resource
          </p>
        </div>
        <div className="flex-sd-list">
          <div className="flex-title-sd-list">
            <div
              className="flex-sd-btn flex-csd-btn"
              style={{ marginBottom: "0px" }}
            >
              <button
                className="btn btn-outline csd-back-btn"
                onClick={() => history.push(`/dashboard/skills/collections`)}
              >
                <img src={arrowBack} />
              </button>
              <h2 className="csd-title">
              <Tooltip title={collectionName}>
                {orgFilterFlag
                  ? collectionName
                  : collectionName?.split("_")[1]?.length > 0
                  ? (
                    collectionName?.length > 20 ?
                    `${(collectionName?.slice(collectionName.indexOf("_") + 1)).substring(0, 18)}...`
                    : (collectionName?.slice(collectionName.indexOf("_") + 1))
                  )
                  : (
                  collectionName?.length > 18 ?
                  `${collectionName.substring(0, 18)}...`
                  : collectionName
                )
                }
                </Tooltip>
              </h2>
            </div>
            <button className="close drawer-close-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-x-circle"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
              </svg>
            </button>
            {askSuper && !orgFilterFlag ? (
              <div className="new-chat-close">
                <Tooltip title="Chat History">
                  <Button
                    type="link"
                    onClick={() => {
                      chatHistoryData(collectionName);
                    }}
                    className="ch-history-btn"
                  >
                    <img src={chatHistoryIcon} width="30" />
                  </Button>
                </Tooltip>
                <Button
                  outline
                  style={{ padding: 0 }}
                  type="link"
                  onClick={() => {
                    setQueryData(queryBody);
                    setQueryResponse("");
                    setChatContext(" ");
                  }}
                >
                  <Tooltip title="New Chat">
                    <img src={editIcon} width="30" />
                  </Tooltip>
                </Button>
              </div>
            ) : null}
          </div>

          <div className="resource-list scrollable">
            <Tabs
              className="cl-tabs"
              defaultActiveKey="1"
              items={items}
              onTabClick={callbackTabClicked}
            />
            {/* <div className="csd-search-bar">
              <Input placeholder="Search Document" onChange={(e) => onSearch(e.target.value)} />
            </div>
            {docList?.length > 0 ?
              docList.map((obj, ind) => {
                if(obj?.length > 0){
                  return (
                    <div className="tl-block" onClick={(e) => {
                      setDocSelected(obj);
                      if($('.tl-block').hasClass('active')){
                        $(e.target).removeClass('active');
                        $(e.target?.parentNode?.parentNode).removeClass('active');
                      } else{
                        $(e.target).addClass('active');
                        $(e.target?.parentNode?.parentNode).addClass('active');
                      }
                
                      if ($('.tl-block').hasClass('active')) {
                        $('.tl-block').removeClass('active');
                        $(e.target).addClass('active');
                        $(e.target?.parentNode?.parentNode).addClass('active');
                      }

                    }}>
                      <div  data-toggle="modal" data-target="#documentDeleteModal">
                      <CheckCircleOutlined style={{ color: '#fff' }} />
                      {userDetails?.role_id == "2" ?
                        <>
                          <Tooltip title="Delete File" onClick={() =>{ 
                                setDocSelected(obj);
                            }}>
                            <DeleteTwoTone className="csd-delete-file"  twoToneColor="#fd2000" />
                          </Tooltip>
                        </>
                      : null}
                      </div>
                      <div className="tl-icon">
                        <div className="cts-avatar">
                          <img src={fileIcon} alt="" />
                        </div>
                      </div>
                      <div className="tl-cont">
                        <p title={obj}>{obj?.length > 50 ? `${obj?.substring(0, 50)}...` : obj}</p>
                        {(loading && ind === docList?.length - 1) ? <span>uploading</span> : <span>uploaded</span>}
                      </div>
                    </div>
                  )
                }
              })
              : null
            } */}
          </div>

          <div className="flex-sd-btn bottom-fix-sd-btn">
            {userDetails?.role_id != "1" ? (
              <Tooltip title="Upload">
                <Button
                  className="btn-home"
                  type="primary"
                  icon={<CloudUploadOutlined />}
                  onClick={() => uploadView()}
                />
              </Tooltip>
            ) : null}
            <button
              className="btn btn-primary"
              onClick={() => queryCollection()}
            >
              Ask AI Coach
            </button>

            {userDetails?.role_id == "2" ? (
              <button className="btn btn-outline" onClick={() => trainedData()}>
                View Trained Data
              </button>
            ) : null}
          </div>
        </div>
      </div>

      {askSuper ? (
        <>
          {chatHistoryFlag ? (
            <div className=" chat-hs-block1 resource-list scrollable">
              <div className="flex-title-chat-hs">
                <h4>Chat History</h4>
                <div className="new-chat-close">
                  <Tooltip title="Hide Chat History">
                    <CloseOutlined onClick={() => setChatHistoryFlag(false)} />
                  </Tooltip>
                </div>
              </div>

              <div className="ch-list-scroll">{chatHistoryList}</div>
            </div>
          ) : null}
          <div className="ms-home chat-history-block">
            <div className="ms-home-inner chat-block2">
              <div className="chat-text-skill">
                <div id="chat" className="scrollable chat-block-scroll">
                  {queryData?.map((obj, ind) => {
                    return obj;
                  })}
                </div>
                {sendAnswer ? (
                  <div className="chat-upload-text">
                    <div className="chat-textbox">
                      <div className="mic-attach">
                        <div className="mic-chat">
                          <img
                            src={micStatus ? micRecording : micDefault}
                            alt=""
                            onClick={speechToText}
                          />
                        </div>
                      </div>
                      <div className="input-block">
                        <textarea
                          id="text-area-input"
                          className="text-chat-textarea"
                          cols="100"
                          style={{ resize: "none" }}
                          value={answerText}
                          onKeyPress={handleKeyPressOnSendAnswer}
                          onChange={(e) => setAnswerText(e.target.value)}
                          type="text"
                          placeholder="Enter your answer here"
                        ></textarea>
                      </div>
                      <div className="smile-submit">
                        <button onClick={() => sendUserAnswer()}>
                          Send <img src={sumbitIcon} alt="" />
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="chat-upload-text">
                    <div
                      className="upload-img-block"
                      style={{
                        display: fileList.length >= 1 ? "block" : "none",
                      }}
                    >
                      <Upload
                        beforeUpload={() => false}
                        listType="picture-card"
                        fileList={fileList}
                        onPreview={handlePreview}
                        onChange={handleChange}
                        ref={uploadRef}
                        accept=".jpg,.png,.pptx,.mp3,.mp4,.wav,.m4a,.mpeg,.flac"
                      ></Upload>
                      {previewImage && (
                        <Image
                          wrapperStyle={{
                            display: "none",
                          }}
                          preview={{
                            visible: previewOpen,
                            onVisibleChange: (visible) =>
                              setPreviewOpen(visible),
                            afterOpenChange: (visible) =>
                              !visible && setPreviewImage(""),
                          }}
                          src={previewImage}
                        />
                      )}
                    </div>
                    <div className="chat-textbox">
                      <div className="mic-attach">
                        <div className="mic-chat">
                          <img
                            src={micStatus ? micRecording : micDefault}
                            alt=""
                            onClick={speechToText}
                          />
                        </div>
                        {!orgFilterFlag ? (
                          // <div className="attach-ico" onClick={() => setImageUploadFlag(!imageUploadFlag)}>
                          //   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-paperclip"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path></svg>
                          // </div>
                          <div
                            className="attach-ico"
                            onClick={handleButtonClick}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="feather feather-paperclip"
                            >
                              <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>
                            </svg>
                          </div>
                        ) : null}
                      </div>
                      <div className="input-block">
                        <textarea
                          id="text-area-input"
                          className="text-chat-textarea"
                          cols="100"
                          style={{
                            resize: "none",
                            minHeight: "30px",
                            background: "transparent",
                          }}
                          value={queryText}
                          onKeyPress={handleKeyPress}
                          onChange={(e) => setQueryText(e.target.value.replace(/[\n\r]/g, ''))}
                          type="text"
                          placeholder="Enter your message here"
                        ></textarea>
                      </div>
                      <div className="smile-submit">
                        <button onClick={() => newCollectionQuery()}>
                          Send <img src={sumbitIcon} alt="" />
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {viewTrainedData ? (
            <div className="ms-home">
              <div className="ms-home-inner-full">
                <div class="tp-title flex-title">
                  <h3>Trained Data</h3>
                  {/* <button className="btn btn-primary btn-sm">Refresh</button> */}
                </div>
                <div className="scrollable-data-table">
                  {loading ? (
                    <div style={{ textAlign: "center", marginTop: "15%" }}>
                      <Loader
                        styles={{ width: "80px", margin: "auto" }}
                        root={{ display: "flex" }}
                      />
                    </div>
                  ) : (
                    <Table
                      className="tb-qst"
                      columns={columns}
                      dataSource={_trainedDataList}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="ms-home">
              <div className="ms-home-inner">
                <div className="ms-ct ms-p1 scrollable">
                  <div
                    className="ms-title"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    {/* <span className="sm-tag">Add Resource</span> */}
                    {!orgFilterFlag ? (
                    <Button
                      type="primary"
                      icon={<ThunderboltOutlined />}
                      className="ant-btn-gradient"
                      onClick={(e) =>
                        history.push(
                          `/collectionWorkspace?name=${collectionName}`
                        )
                      }
                    >
                      Switch to PowerView
                    </Button>
                    ) : null}
                    {/* <a href="https://analytics-qa.supervity.ai/" className="analytics-btn" target="_blank"><img src={analyticsIcon} /> View Analytics</a> */}
                  </div>

                  {loading ? (
                    <div style={{ textAlign: "center", marginTop: "15%" }}>
                      <Loader
                        styles={{ width: "80px", margin: "auto" }}
                        root={{ display: "flex" }}
                      />
                    </div>
                  ) : (
                    <div className="ms-flex ms-flex-3">
                      <div
                        className={
                          userDetails?.role_id !== "1"
                            ? collectionSource === "database"
                              ? "ms-box disabled"
                              : uploadInput
                              ? "ms-box active"
                              : "ms-box"
                            : "ms-box disabled"
                        }
                        onClick={() => {
                          setUploadInput(true);
                          setAddText(false);
                          setUrlInput(false);
                          setIsEditing(false);
                        }}
                      >
                        <div className="ms-box-icon">
                          <img src={fileIcon} />
                        </div>
                        <div className="ms-box-ct">
                          <h5>Upload Document From</h5>
                          <p>
                            Upload the document and start asking questions!
                            Configure the AI Coach with your team's or
                            organization's knowledge by simply adding
                            collections of documents. Once uploaded, AI Coach
                            can help you discover information from the
                            collection of data.
                          </p>
                          <p>
                            Valid file types: *.pptx, *.docx, *.xlsx, *.pdf,
                            *.pptx, *.mp3, *.mp4, *.wav, *.m4a, *.mpeg, *.flac
                          </p>
                          <p>Please ensure your files meet the following requirements:</p>
                          <p>Documents (PDF, PPTX, DOCX): Max size 64MB</p>
                          <p>Audio/Video Files: Max size 24MB</p>
                          <p>Spreadsheets (XLSX): Max size 10MB</p>
                        </div>
                      </div>

                      <div
                        className={
                          userDetails?.role_id !== "1"
                            ? collectionSource === "database"
                              ? "ms-box disabled"
                              : urlInput
                              ? "ms-box active"
                              : "ms-box"
                            : "ms-box disabled"
                        }
                        onClick={() => {
                          setUrlInput(true);
                          setUploadInput(false);
                          setAddText(false);
                        }}
                      >
                        <div className="ms-box-icon">
                          <img src={urlIcon} />
                        </div>
                        <div className="ms-box-ct">
                          <h5>Add URL</h5>
                          <p>
                            Add data from public URLs and start asking
                            questions! Configure the AI Coach with your team's
                            or organization's knowledge by simply adding
                            collections of public URLs. Once added, AI Coach can
                            help you discover information from the collection of
                            data. Only public URLs are allowed.
                          </p>
                        </div>
                      </div>

                      <div
                        className={
                          userDetails?.role_id !== "1"
                            ? collectionSource === "database" || orgFilterFlag
                              ? "ms-box disabled"
                              : isEditing || addText
                              ? "ms-box active"
                              : "ms-box"
                            : "ms-box disabled"
                        }
                        onClick={() => {
                          setAddText(true);
                          setUploadInput(false);
                          setUrlInput(false);
                          setIsEditing(false);
                        }}
                      >
                        <div className="ms-box-icon">
                          <img src={textIcon} />
                        </div>
                        <div className="ms-box-ct">
                          <h5>Add Text</h5>
                          <p>
                            Add text and start asking questions! Configure the
                            AI Coach with your team's or organization's
                            knowledge by simply adding text. Once added, AI
                            Coach can help you discover information from the
                            collection of data.
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {urlInput ? (
                    <>
                      {/* <h4>Enter URL</h4>
                <div className="rsc-auth-block">
                  <input type="text" placeholder="Enter URL" onChange={(e) => setUploadURLText(e.target.value)} />
                </div>
                <br />
                <h4>Resource name</h4>
                <div className="rsc-auth-block">
                  <input type="text" placeholder="Enter Resource name" onChange={(e) => setResourceName(e.target.value)} />
                </div>
                <div className="btn-flex-1 text-center">
                        <Button type="primary" onClick={(e) => addURL()}>Submit</Button>
                </div>       */}
                      <div className="ms-auth-block upload-box">
                        <h3>Add URL</h3>
                        <br />
                        <div className="radio-options">
                          <Radio.Group
                            onChange={onChangeScrape}
                            defaultValue={valueScrape}
                          >
                            <Radio value={1}>Scrape URL Only</Radio>
                            <Radio value={2}>Scrape Entire Website</Radio>
                          </Radio.Group>
                        </div>
                        <div className="img-selector">
                          <div className="up-flex-items">
                            <Input
                              type="text"
                              value={uploadURLText}
                              placeholder="Enter URL"
                              onChange={(e) => setUploadURLText(e.target.value)}
                            />
                          </div>

                          <div className="up-flex-items doc-url">
                            <h4>Resource name</h4>
                            <div className="input-clear">
                              <Input
                                type="text"
                                value={resourceName}
                                placeholder="Enter Resource name"
                                onChange={(e) =>
                                  setResourceName(e.target.value)
                                }
                              />
                            </div>
                          </div>

                          <div className="btn-flex-1 text-center">
                            <Button type="primary" onClick={(e) => addURL()}>
                              Submit
                            </Button>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : addText ? (
                    <>
                      {/* Code for Text Input */}
                      <div className="ms-auth-block upload-box">
                        <h3>Add Text</h3>
                        <br />
                        {!isEditing ? (
                          <>
                            <div className="up-flex-items doc-url">
                              <h4>Resource name</h4>
                              <div className="input-clear">
                                <Input
                                  type="text"
                                  value={resourceName}
                                  placeholder="Enter Resource name"
                                  onChange={(e) =>
                                    setResourceName(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                            <div className="img-selector">
                              <div className="up-flex-items doc-url">
                                <h4>Enter your text</h4>
                                <div className="input-clear">
                                  <TextArea
                                    rows={4}
                                    type="text"
                                    value={textValue}
                                    placeholder="Enter your text here"
                                    onChange={(e) =>
                                      setTextValue(e.target.value)
                                    }
                                  />
                                </div>
                              </div>

                              <div className="btn-flex-1 text-center">
                                {isLoading ? (
                                  <button className="btn btn-primary">
                                    <div class="sp sp-circle text-light"></div>
                                  </button>
                                ) : (
                                  <Button
                                    type="primary"
                                    onClick={() => uploadText()}
                                  >
                                    Submit
                                  </Button>
                                )}
                              </div>
                            </div>
                          </>
                        ) : null}
                      </div>
                    </>
                  ) : isEditing ? (
                    <>
                      {/* Code for Text Input */}
                      <div className="ms-auth-block upload-box">
                        <div className="img-selector">
                          <div className="up-flex-items doc-url">
                            <h4>Enter your text</h4>
                            <div className="input-clear">
                              <TextArea
                                rows={4}
                                type="text"
                                value={updatedTextValue}
                                placeholder="Enter your text here"
                                onChange={(e) =>
                                  setUpdatedTextValue(e.target.value)
                                }
                              />
                            </div>
                          </div>

                          <div className="btn-flex-1 text-center">
                            {isLoading ? (
                              <button className="btn btn-primary">
                                <div class="sp sp-circle text-light"></div>
                              </button>
                            ) : (
                              <Button
                                type="primary"
                                onClick={() => updateText()}
                              >
                                Submit
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {userDetails?.role_id != "1" ? (
                        <>
                          <div className="ms-auth-block upload-box">
                            <h3>Upload Document From</h3>
                            <br />

                            <Radio.Group
                              defaultValue={"local_upload"}
                              options={optionsWithDisabled}
                              onChange={(e) => {
                                setUploadType(e.target.value);
                              }}
                              // value={value4}
                              optionType="button"
                              buttonStyle="solid"
                            />

                            {uploadType == "local_upload" ? (
                              <div className="img-selector">
                                <div className="up-flex-items">
                                  <div className="input-clear">
                                    <Input
                                      type="text"
                                      placeholder="Enter File URL"
                                      value={filePath}
                                      disabled={collectionSource === "database"}
                                    />
                                    {filePath?.length > 0 ? (
                                      <Button
                                        className="ip-clear-btn"
                                        type="danger"
                                        shape="circle"
                                        icon={<CloseOutlined />}
                                        size={10}
                                        onClick={(e) => clearFilePath()}
                                      />
                                    ) : null}
                                  </div>
                                 
                                  <Upload {...props}>
                                    {fileUploading ? (
                                      <Button>
                                        <div className="sp sp-circle text-light"></div>
                                      </Button>
                                    ) : (
                                      <Button
                                        icon={<UploadOutlined />}
                                        disabled={
                                          collectionSource === "database"
                                        }
                                      >
                                        Browse
                                      </Button>
                                    )}
                                  </Upload>

                                  {/* <Button type="primary" onClick={(e) => addFile()}>Submit</Button> */}
                                </div>

                                <div className="up-flex-items doc-url">
                                  {!orgFilterFlag ? (
                                    <Checkbox
                                      disabled={collectionSource === "database"}
                                      onChange={(e) => {
                                        e.target.checked
                                          ? setOcrFlag("true")
                                          : setOcrFlag("false");
                                      }}
                                    >
                                      Use OCR
                                    </Checkbox>
                                  ) : null}
                                  <h5>Reference Document URL(Optional)</h5>
                                  <div className="input-clear">
                                    <Input
                                      placeholder="Enter Document URL"
                                      value={docURL}
                                      onChange={(e) =>
                                        onDocumentURLClick(e.target.value)
                                      }
                                      disabled={collectionSource === "database"}
                                    />
                                  </div>
                                </div>

                                <div className="btn-flex-1 text-center">
                                  <React.Fragment>
                                    {isLoading ? (
                                      <button className="btn btn-primary">
                                        <div class="sp sp-circle text-light"></div>
                                      </button>
                                    ) : (
                                      <Button
                                        type="primary"
                                        onClick={(e) => addFile()}
                                      >
                                        Submit
                                      </Button>
                                    )}
                                  </React.Fragment>
                                </div>
                              </div>
                            ) : null}

                            {uploadType == "sharepoint" ? (
                              <>
                                {/* Sharepoint */}
                                <div className="sharepoint-block">
                                  <div className="up-flex-items">
                                    <div>
                                      <Button type="primary"
                                        onClick={(e) => handleSharePoint()}>Connect SharePoint
                                        </Button>
                                    </div>
                                    {driveFolderSelected ? (
                                    <div className="input-clear">
                                      <Select
                                        value={fileTypeDefault}
                                        mode="multiple"
                                        allowClear
                                        showArrow="true"
                                        style={{
                                          width: "100%",
                                        }}
                                        placeholder="Select the file type if choosing a folder (Optional)"
                                        onChange={handleChangeFileType}
                                        options={[
                                          {
                                            value: ".pdf",
                                            label: ".pdf",
                                          },
                                          {
                                            value: ".docx",
                                            label: ".docx",
                                          },
                                          {
                                            value: ".xlsx",
                                            label: ".xlsx",
                                          },
                                          {
                                            value: ".pptx",
                                            label: ".pptx",
                                          },
                                        ]}
                                      />
                                    </div>
                                    ) : null}
                                    {/* <div className="input-clear">
                                      <Input
                                        onChange={(e) =>
                                          setClientID(e.target.value)
                                        }
                                        value={clientID}
                                        placeholder="Client ID"
                                        suffix={
                                          <Popover
                                            content={clientTenantId}
                                            placement="top"
                                          >
                                            <InfoCircleOutlined
                                              style={{
                                                color: "rgba(0,0,0,.45)",
                                              }}
                                            />
                                          </Popover>
                                        }
                                      />
                                    </div>
                                    <div className="input-clear">
                                      <Input
                                        onChange={(e) =>
                                          setClientSecretID(e.target.value)
                                        }
                                        value={clientSecretID}
                                        placeholder="Client Secret"
                                        suffix={
                                          <Popover
                                            content={clientSecret}
                                            placement="top"
                                          >
                                            <InfoCircleOutlined
                                              style={{
                                                color: "rgba(0,0,0,.45)",
                                              }}
                                            />
                                          </Popover>
                                        }
                                      />
                                    </div>
                                    <div className="input-clear">
                                      <Input
                                        onChange={(e) =>
                                          setTenantID(e.target.value)
                                        }
                                        value={tenantID}
                                        placeholder="Tenant ID"
                                        suffix={
                                          <Popover
                                            content={clientTenantId}
                                            placement="top"
                                          >
                                            <InfoCircleOutlined
                                              style={{
                                                color: "rgba(0,0,0,.45)",
                                              }}
                                            />
                                          </Popover>
                                        }
                                      />
                                    </div>
                                    <div className="input-clear">
                                      <Input
                                        onChange={(e) =>
                                          setUploadSiteName(e.target.value)
                                        }
                                        value={uploadSiteName}
                                        placeholder="Site Name"
                                        suffix={
                                          <Popover
                                            content={siteName}
                                            placement="right"
                                          >
                                            <InfoCircleOutlined
                                              style={{
                                                color: "rgba(0,0,0,.45)",
                                              }}
                                            />
                                          </Popover>
                                        }
                                      />
                                    </div> */}
                                  </div>
                                  <Modal className="file-list-modal" title="Select Files/Folder" open={isFolderModalOpen} onOk={sendSelectedSharePointData} onCancel={dummyShare} style={{top:'20px'}} footer={folders.length > 2 ? [
                                      <Button key="cancel" onClick={dummyShare}>Cancel</Button>,
                                      <Button key="ok" type="primary" onClick={sendSelectedSharePointData}>Ok</Button>
                                    ] : null} >
                                  <div className="file-header">
                                    {folders?.length > 1 &&<div className="icon-back" onClick={handleBack}>
                                      <Button> <img style={{width: '25px'}} src={fileBackIcon}/> </Button>
                                    </div>}
                                    <div className="search-file">
                                    <Search
                                      placeholder="input search text"
                                      allowClear
                                      enterButton="Search"
                                      onSearch={onSearchFile}
                                    />
                                    </div>
                                  </div>
                                  <div className="scrollable scroll-modal" style={{ maxHeight: "50dvh", overflowY: "auto" }}>
                                    {folders.length != 0 && folders[folders.length-1] != 0 ? folders[folders.length-1].map((folder) => (
                                      <div className="fl-list-item" key={folder.id} onClick={() => handleSelectFolderV2(folder)} onDoubleClick={() => handleSelectFolderV2(folder,true)}>
                                        
                                        <div className={selectFolder.some(obj => obj.id == folder.id) ? "img-text-file active" : "img-text-file"}>
                                          <div className="img-text-left" >
                                            <span>{folder?.file ? <img src={fileListIcon} /> : <img src={folderListIcon} />}</span>
                                            <p>{folder.displayName ? folder.displayName : folder.name}</p>
                                          </div>                                          
                                          {folders.length > 0 && <div className={selectFolder.some(obj => obj.id == folder.id) ? "check-btn active" : "check-btn"}>
                                            <img src={checkListIcon} alt="" />
                                          </div>}
                                        </div>
                                      </div>
                                    )) : <div className="fl-list-item">No files contains</div>}
                                  </div>                                    
                                  </Modal>
                                  {/* <div className="up-flex-items">
                                    <div className="input-clear">
                                      <Input
                                        onChange={(e) =>
                                          setSharePointSiteID(e.target.value)
                                        }
                                        value={sharePointSiteID}
                                        placeholder="Sharepoint Site ID"
                                        suffix={
                                          <Popover
                                            content={siteID}
                                            placement="top"
                                          >
                                            <InfoCircleOutlined
                                              style={{
                                                color: "rgba(0,0,0,.45)",
                                              }}
                                            />
                                          </Popover>
                                        }
                                      />
                                    </div>
                                    <div className="input-clear">
                                      <Input
                                        onChange={(e) =>
                                          setFolderPath(e.target.value)
                                        }
                                        value={folderPath}
                                        placeholder="Folder Path"
                                        suffix={
                                          <Popover
                                            content={folderName}
                                            placement="top"
                                          >
                                            <InfoCircleOutlined
                                              style={{
                                                color: "rgba(0,0,0,.45)",
                                              }}
                                            />
                                          </Popover>
                                        }
                                      />
                                    </div>
                                    <div className="input-clear">
                                      <Select
                                        value={fileTypeDefault}
                                        mode="multiple"
                                        allowClear
                                        showArrow="true"
                                        style={{
                                          width: "100%",
                                        }}
                                        placeholder="Please Select File Type"
                                        onChange={handleChangeFileType}
                                        options={[
                                          {
                                            value: ".pdf",
                                            label: ".pdf",
                                          },
                                          {
                                            value: ".docx",
                                            label: ".docx",
                                          },
                                          {
                                            value: ".xlsx",
                                            label: ".xlsx",
                                          },
                                          {
                                            value: ".pptx",
                                            label: ".pptx",
                                          },
                                        ]}
                                      />
                                    </div>
                                  </div> */}
                                  {/* <div className="btn-flex-1 text-center">
                                    <React.Fragment>
                                      {isLoading ? (
                                        <button className="btn btn-primary">
                                          <div class="sp sp-circle text-light"></div>
                                        </button>
                                      ) : (
                                        <Button
                                          type="primary"
                                          onClick={(e) => sendSharepointData()}
                                        >
                                          Submit
                                        </Button>
                                      )}
                                    </React.Fragment>
                                  </div> */}
                                </div>
                                {/* End of sharepoint */}
                              </>
                            ) : null}

                            {uploadType == "google_drive" ? (
                              <>
                                {/* Google Drive */}
                                <div className="googledrive-block">
                                  <div className="up-flex-items">
                                    <div>
                                      <Button type="primary"
                                        onClick={(e) => handleOpenPicker()}>Connect Google drive
                                        </Button>
                                    </div>
                                    {/* <div className="input-clear">
                                      <Input
                                        onChange={(e) =>
                                          setFolderPath(e.target.value)
                                        }
                                        value={folderPath}
                                        placeholder="Folder ID"
                                        suffix={
                                          <Popover
                                            content={folderIdG}
                                            placement="top"
                                          >
                                            <InfoCircleOutlined
                                              style={{
                                                color: "rgba(0,0,0,.45)",
                                              }}
                                            />
                                          </Popover>
                                        }
                                      />
                                    </div> */}
                                    {/* <div className="input-clear">
                                      <Upload
                                        {...propsUploadTokenFile}
                                        beforeUpload={() => false}
                                        showUploadList={false}
                                        className="upload-input-full"
                                      >
                                        <Button type="default" block>
                                          {filePath?.length > 0
                                            ? filePath
                                            : `{} Upload Token File`}
                                          <Popover
                                            content={tokenG}
                                            placement="top"
                                          >
                                            <InfoCircleOutlined
                                              style={{
                                                color: "rgba(0,0,0,.45)",
                                              }}
                                            />
                                          </Popover>
                                        </Button>
                                      </Upload>
                                    </div> */}
                                    {driveFolderSelected ? (
                                    <div className="input-clear">
                                      <Select
                                        value={fileTypeDefault}
                                        mode="multiple"
                                        allowClear
                                        showArrow="true"
                                        style={{
                                          width: "100%",
                                        }}
                                        placeholder="Select the file type if choosing a folder (Optional)"
                                        onChange={handleChangeFileType}
                                        options={[
                                          {
                                            value: ".pdf",
                                            label: ".pdf",
                                          },
                                          {
                                            value: ".docx",
                                            label: ".docx",
                                          },
                                          {
                                            value: ".xlsx",
                                            label: ".xlsx",
                                          },
                                          {
                                            value: ".pptx",
                                            label: ".pptx",
                                          },
                                        ]}
                                      />
                                    </div> ) : null}
                                  </div>
                                  {/* <div className="btn-flex-1 text-center">
                                    <React.Fragment>
                                      {isLoading ? (
                                        <button className="btn btn-primary">
                                          <div class="sp sp-circle text-light"></div>
                                        </button>
                                      ) : (
                                        <Button
                                          type="primary"
                                          onClick={(e) => sendGoogleDriveData()}
                                        >
                                          Submit
                                        </Button>
                                      )}
                                    </React.Fragment>
                                  </div> */}
                                </div>
                                {/* End of Google Drive */}
                              </>
                            ) : null}
                          </div>
                        </>
                      ) : null}
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      )}

      <div
        className="modal fade qa-modal1"
        id="documentDeleteModal"
        role="dialog"
      >
        <div className="modal-dialog modal-sm">
          <div className="modal-content share-modal">
            <button type="button" className="close" data-dismiss="modal">
              &times;
            </button>
            <div className="modal-body">
              <h3 className="qa-modal-title">Delete</h3>
              <div>
                <h5>Please confirm delete action.</h5>
              </div>

              <div className="frm-btns fb-right">
                <button
                  className="btn-outline"
                  data-dismiss="modal"
                  onClick={() => {
                    setDocSelected("");
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    deleteDoc(docSelected);
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade qa-modal1"
        id="walkthroughDeleteModal"
        role="dialog"
      >
        <div className="modal-dialog modal-sm">
          <div className="modal-content share-modal">
            <button type="button" className="close" data-dismiss="modal">
              &times;
            </button>
            <div className="modal-body">
              <h3 className="qa-modal-title">Delete</h3>
              <div>
                <h5>Please confirm delete action.</h5>
              </div>

              <div className="frm-btns fb-right">
                <button
                  className="btn-outline"
                  data-dismiss="modal"
                  onClick={() => {
                    setWalkthroughToDelete("");
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    deleteWalkthrough();
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        className="table-modal"
        title="Edit Answer"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="modal-edit-qst">
          <TextArea
            value={editAnswerValue}
            onChange={(e) => setEditAnswerValue(e.target.value)}
            placeholder="Write Your Answer"
            autoSize={{ minRows: 3, maxRows: 8 }}
          />
        </div>
      </Modal>
      <Modal
        className="table-modal"
        title="Old Answer"
        open={isAnswerOld}
        onOk={handleOkOld}
        onCancel={handleCancelOld}
      >
        <p>{oldAnswerText}</p>
      </Modal>
      <Modal
        className="table-modal"
        title="Updated Answer"
        open={isAnswerNew}
        onOk={handleOkNew}
        onCancel={handleCancelNew}
      >
        <p>{newAnswerText}</p>
      </Modal>

      <audio id="audioPlayer"></audio>
    </div>
  );
};

export default connect(null, {})(Collection);
